function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}
$(document).ready(function () {
  "use strict";
  console.log("Hello world");
  // In account scripts
  $(".order--container").on("click", function () {
    if ($(this).hasClass("follow__link") == false) {
      var orderId = $(this).attr("order-id");
      $('.order__details[order-id="' + orderId + '"]')
        .slideToggle(200)
        .toggleClass("is-active");
      $(this).toggleClass("child-active");
      $(this)
        .children(".open__line__items--link")
        .children()
        .toggleClass("arrow--top arrow--bottom");
    }
  });

  $("#reset-password").click(function () {
    $("#connexion").css("display", "none");
    $("#reset").fadeIn("slow");
  });

  $("#infos-produits-papier").on("click", function () {
    var isChecked = $(this).prop("checked");
    var data = { attributes: {} };
    var newValue = isChecked
      ? "infos_produits_papier=Oui"
      : "infos_produits_papier=Non";

    data.attributes["infos_produits_papier"] = newValue;

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function success(response) {},
      error: function error(_error) {
        console.log("erreur");
      },
    });
  });

  $(".add__to__cart--order").on("click", function () {
    var order = $(this).attr("order_id");
    var data = { updates: {} };

    $(".image-product-order").each(function () {
      if ($(this).attr("order_id") == order) {
        var variantId = $(this).attr("variant_id");
        data.updates[variantId] = 1;
      }
    });
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function success(response) {
        document.dispatchEvent(new CustomEvent("addToCart"));
      },
      error: function error(_error) {
        console.log("erreur");
      },
    });
  });

  var url = window.backend.url;

  var email = window.general.customerEmail;
  //var email = 'manon.pontillo@gmail.com'
  if (window.location.pathname == "/account") {
    $.ajax({
      type: "GET",
      url: url + "diagnostic-beaute?email=" + email,
      crossDomain: true,
      success: function success(diag) {
        $(".faire-diagnostic").hide();
        $(".link-diagnostic-fait").attr(
          "href",
          "/pages/diagnostic-resultat?email=" + email
        );
      },
      error: function error(_error2) {
        $(".diagnostic-fait").hide();
      },
    });
  }
  ("use strict");

  $("#accordion-navigation .plus__icon").show();
  $("#accordion-navigation")
    .find("li.extend")
    .click(function (e) {
      $(this).children(".extended-submenu").slideToggle("fast");
      $(this)
        .children(".nav--title")
        .children(".plus__icon")
        .toggleClass("opened");
      $(this).toggleClass("active");
    });

  if (window.location.pathname.indexOf("blog") > -1) {
    var CheminComplet = document.location.href;
    var CheminCompletFb =
      "http://www.facebook.com/sharer.php?u=" + CheminComplet + "&t=partage";
    var CheminCompletPinterest =
      "http://pinterest.com/pin/create/button/?url=" + CheminComplet;
    var CheminCompletTwitter =
      "http://twitter.com/share?text=Oolution&url=" +
      CheminComplet +
      "&hashtags=oolution";

    $("#share-link--facebook").attr("href", CheminCompletFb);
    $("#share-link--pinterest").attr("href", CheminCompletPinterest);
    $("#share-link--twitter").attr("href", CheminCompletTwitter);
  }

  $(".second-nav .link--title").on("click", function () {
    $(".navigation--desktop-blog").css("display", "none");
    $(this).children(".navigation--desktop-blog").css("display", "block");
  });

  $(document).on("click", function (e) {
    var container = $(".link--title");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".second-nav .link--title .navigation--desktop-blog").css(
        "display",
        "none"
      );
    }
  });
  ("use strict");

  $(".button--cookie").click(function () {
    $("#cookie--banner").hide();
  });

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  if (getCookie("cookies-accepted") == "yes") {
  } else {
    setTimeout(function () {
      $("#cookie--banner").addClass("apparition--cookie");
      var CookieDate = new Date();
      CookieDate.setMonth(CookieDate.getMonth() + 12);
      document.cookie =
        "cookies-accepted=yes; expires=" +
        CookieDate.toGMTString() +
        "; path=/";
    }, 3000);
  }
  ("use strict");

  function checkIfAnalyticsLoaded() {
    if (typeof ga === "undefined") {
      setTimeout(checkIfAnalyticsLoaded, 500);
    } else {
      // Diagnostic
      // =======================================================================
      if (window.location.pathname.indexOf("diagnostic-de-peau") > -1) {
        console.log("DEBUG GA");
        ga("send", "event", "Diagnostic beauté", "Page accueil", "1");
      }

      $(".diagnostic--button").on("click", function () {
        ga("send", "event", "Diagnostic beauté", "Commencé", "1");
        ga("send", "event", "Diagnostic beauté", "Question", "question-1");
      });

      document.addEventListener(
        "question-diag",
        function (elem) {
          var question = event.detail.currentQuestion + 2;
          ga(
            "send",
            "event",
            "Diagnostic beauté",
            "Question",
            "question-" + question
          );
        },
        false
      );

      document.addEventListener(
        "perso-question",
        function (elem) {
          ga(
            "send",
            "event",
            "Diagnostic beauté",
            "Questions personnelles",
            "1"
          );
        },
        false
      );

      document.addEventListener(
        "validation-succes",
        function (elem) {
          ga("send", "event", "Diagnostic beauté", "Complété", "Succès");
        },
        false
      );

      document.addEventListener(
        "validation-error",
        function (elem) {
          ga("send", "event", "Diagnostic beauté", "Complété", "Echec");
        },
        false
      );

      if (window.location.pathname.indexOf("diagnostic-resultat") > -1) {
        ga("send", "event", "Diagnostic beauté", "Résultats", "1");
      }
    }
  }

  checkIfAnalyticsLoaded();
  ("use strict");

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  if (getCookie("show-modal-newsletter") == "yes") {
  } else {
    setTimeout(function () {
      if (parseInt(getCookie("visited")) >= 2) {
        $("#modal-cart-page-overlay").show().css("display", "flex");
        var CookieDate = new Date();
        CookieDate.setMonth(CookieDate.getMonth() + 8);
        document.cookie =
          "show-modal-newsletter=yes; expires=" +
          CookieDate.toGMTString() +
          "; path=/";
      }
    }, 4000);
  }

  $("#close-modal-cart").on("click", function () {
    $("#modal-cart-page-overlay").hide();
  });
  $(document).mouseup(function (e) {
    var container = $("#modal-cart-page");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $("#modal-cart-page-overlay").hide();
    }
  });

  if (!getCookie("visited")) {
    var CookieDateVisited = new Date();
    CookieDateVisited.setDate(CookieDateVisited.getDate() + 7);
    document.cookie =
      "visited=0; expires=" + CookieDateVisited.toGMTString() + "; path=/";
  } else {
    var visited = parseInt(getCookie("visited")); // visited = 0
    visited++; // increase counter of visits
    var CookieDateVisitedUpdate = new Date();
    CookieDateVisitedUpdate.setDate(CookieDateVisitedUpdate.getDate() + 7);
    document.cookie =
      "visited=" +
      visited +
      "; expires=" +
      CookieDateVisitedUpdate.toGMTString() +
      "; path=/";
  }
  ("use strict");

  document.addEventListener(
    "cart:open",
    function (elem) {
      $("#cart__drawer").addClass("opened");
      $("#page__overlay").addClass("opened");
      $("#page__overlay").attr("for", "drawer");
      if (window.matchMedia("(min-width: 768px)").matches) {
        setTimeout(function () {
          $("#drawer__cart--exta-infos").addClass("opened");
        }, 350);
      }
    },
    false
  );
  ("use strict");

  if (window.matchMedia("(min-width: 1101px)").matches) {
    $(".button__action--cart-preview").mouseenter(function (e) {
      $("#cart__preview").addClass("opened");
      handleNavbarHover("opened");
    });

    $("#cart__preview").mouseenter(function (e) {
      $("#cart__preview").addClass("opened");
      handleNavbarHover("opened");
    });

    $("#cart__preview").mouseleave(function (e) {
      $("#cart__preview").removeClass("opened");
      $("#cart__preview").removeClass("opened--added-to-cart");

      $(".link--text-style--cart").removeClass("link__active");
      if ($(e.relatedTarget).is(".link--text-style")) {
      } else {
        handleNavbarHover("closed");
      }
    });

    $(".button__action--cart-preview").mouseleave(function (e) {
      $("#cart__preview").removeClass("opened");
      $("#cart__preview").removeClass("opened--added-to-cart");

      $(".link--text-style--cart").removeClass("link__active");
      if (
        $(e.relatedTarget).is(
          ".links__container--half, #navigation__links--list, .link--text-style, .announcement__bar--container"
        )
      ) {
      } else {
        handleNavbarHover("closed");
      }
    });
  } else {
    $(".button__action--cart-preview").on("click", function () {
      if ($("#cart__preview").hasClass("opened")) {
        $("#cart__preview").removeClass("opened");
        $("#cart__preview").removeClass("opened--added-to-cart");
        $("#page__overlay--navigation").removeClass("opened");
        handleNavbarHover("closed");
      } else {
        $("#cart__preview").addClass("opened");
        //$('#page__overlay--navigation').addClass('opened');
        handleNavbarHover("opened");
      }
    });

    $(".close--cart-preview").on("click", function () {
      $("#cart__preview").removeClass("opened opened--added-to-cart");
      $("#cart__preview").removeClass("opened--added-to-cart");
      $("#page__overlay--navigation").removeClass("opened");
      handleNavbarHover("closed");
    });

    $("#page__overlay--navigation").on("click", function () {
      $("#cart__preview").removeClass("opened opened--added-to-cart");
      $("#cart__preview").removeClass("opened--added-to-cart");
      $("#page__overlay--navigation").removeClass("opened");
      handleNavbarHover("closed");
    });
  }

  if ($(document).scrollTop() > 20) {
    $("#cart__preview").css("top", "48px");
  }

  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      $("#cart__preview").css("top", "48px");
    } else {
      $("#cart__preview").css("top", "85px");
    }
  });

  function handleNavbarHover(status) {
    if (window.location.pathname == "/") {
      if (window.matchMedia("(min-width: 1101px)").matches) {
        if (status == "opened") {
          $(".link--text-style--cart").addClass("link__active");
          $("#navigation--container").removeClass("transparent--nav");
          $("#main__logo--svg").removeClass("logo--white");
        } else {
          //$('#navigation--container').addClass('transparent--nav');
          $("#main__logo--svg").addClass("logo--white");
        }
      }
    }
  }

  ("use strict");

  // Add to cart funnction
  if (window.location.pathname == "/cart") {
    window.cart.drawer = false;
  }

  // setTimeout(function(){
  //   $('.button__action--cart-preview').click()
  // }, 1500);
  // $('.button__action--cart-preview').click()

  $("body").on("click", ".add__to__cart--grid-item", function (e) {
    e.preventDefault();
    var $this = $(this);
    var variant_id = $this.attr("product-variant");
    var qty = 1;
    var objUpdate = { quantity: qty, id: variant_id };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: objUpdate,
      dataType: "json",
      success: function success(response) {
        updateCartData();
        document.dispatchEvent(new CustomEvent("product:added"));
        setTimeout(function () {
          $this.children(".button--loading").css("display", "none");
          $this.children(".button--text").show();
        }, 300);

        if (window.matchMedia("(max-width: 767px)").matches) {
          setTimeout(function () {
            $("#drawer__cart--exta-infos").removeClass("opened");
          }, 500);
        }
      },
      error: function error(_error) {
        console.log("erreur");
      },
    });
  });

  $("body").on("click", ".add__to__cart", function (e) {
    e.preventDefault();
    var variantId = $(this).attr("variant-id");
    var available = $(this).attr("variant-available");
    var productHandle = $(this).attr("product-handle");
    var variants = $(this).attr("variants");
    var type = $(this).attr("button-type");
    var openModale = $(this).attr("open-selector");
    var $this = $(this);
    var rechargeAddedToCart = false;
    var rechargeFrequencies = [];

    $this.children(".button--text").css("display", "none");
    $this.children(".button--loading").css("display", "block");

    // Fonction pour traiter l'ajout au panier après détection ReCharge
    function processAddToCart() {
      // Détection ReCharge moderne
      var rechargeData = getReChargeData();
      if (rechargeData.isSubscription) {
        rechargeAddedToCart = true;
        console.log("✅ [ReCharge] Abonnement détecté dans theme-apm.js");
      }

      if (available == "true" || available == true) {
        if (variants && openModale) {
          document.dispatchEvent(
            new CustomEvent("product-grid-modal:open", {
              detail: { productHandle: productHandle },
            })
          );
        } else if (variantId) {
          var qty = 1;
          if (type == "product") {
            qty = $(".product__qty--container .quantity__current").val();
          }
          var objUpdate = { quantity: qty, id: variantId };

          // Récupérer le selling plan ReCharge
          var sellingPlanId = "";
          if (rechargeData.isSubscription && rechargeData.sellingPlanId) {
            sellingPlanId = rechargeData.sellingPlanId;
            console.log("✅ [ReCharge] Selling plan ajouté:", sellingPlanId);
          } else {
            // Fallback pour Yotpo
            const selectedSellingPlanEl = document.querySelector(
              '.yotpo-selected [name="selling_plan"]'
            );
            sellingPlanId = selectedSellingPlanEl && selectedSellingPlanEl.value
              ? selectedSellingPlanEl.value
              : "";
          }

          if (sellingPlanId) {
            objUpdate["selling_plan"] = sellingPlanId;
          }

          // oolution --> on ne peut pas s'abonner aux petites tailles
          var grandeTaille = $(
            '.select__custom--value[subscription-variant="taille--big"]'
          )
            .text()
            .trim();
          var tailleSelectionnee = $("#select__custom--1").text().trim();
          if (grandeTaille && grandeTaille != tailleSelectionnee) {
            objUpdate["properties[recharge_prevent]"] = "true";
          }

          if (rechargeAddedToCart) {
            // Utiliser les données ReCharge modernes
            if (rechargeData.sellingPlanId) {
              objUpdate["selling_plan"] = rechargeData.sellingPlanId;
            }
            objUpdate["properties[recharge]"] = "true";
            console.log("✅ [ReCharge] Propriétés d'abonnement ajoutées");
          }

          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: objUpdate,
            dataType: "json",
            success: function success(response) {
              // On render le cart via le module shippinh-module-cart.js
              console.log("pass here");
              updateCartData();
              document.dispatchEvent(new CustomEvent("product:added"));

              if ($("#empty__cart--title").length > 0) {
                location.reload(true);
              }

              document.dispatchEvent(new CustomEvent("cart:open"));
              $this.children(".button--text").css("display", "block");
              $this.children(".button--loading").css("display", "none");
            },
            error: function error(_error2) {
              console.log("erreur");
              console.log(_error2);
            },
          });
        }
      } else {
        console.log("product anaivalable");
        $this.children(".button--text").css("display", "block");
        $this.children(".button--loading").css("display", "none");
      }
    }

    // Attendre que le widget ReCharge soit initialisé avant de traiter l'ajout au panier
    waitForReChargeWidget(processAddToCart);
  });

  $("body").on("change", ".qty--input", function (e) {
    e.preventDefault();
    var $this = $(this);
    var variantId = $(this).attr("variant-id");
    var variantQty = $this.val();

    if (variantId) {
      var data = { updates: {} };
      data.updates[variantId] = variantQty;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function success(response) {
          // On render le cart via le module shippinh-module-cart.js
          updateCartData();
        },
        error: function error(_error3) {
          console.log("erreur");
        },
      });
    }
  });

  $("body").on("click", ".remove--line-item", function (e) {
    e.preventDefault();
    var $this = $(this);
    var key = $(this).attr("key");
    var type = $(this).attr("type");
    var giftProduct = $(this).attr("gift");

    var data = { updates: {} };
    data.updates[key] = 0;
    setTimeout(function () {
      $('.cart__item--container[key="' + key + '"]').remove();
    }, 300);
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function success(response) {
        updateCartData();
      },
      error: function error(_error4) {
        console.log("erreur");
      },
    });
  });

  var updateCartView = function updateCartView() {
    var isMobile = window.innerWidth <= 1000;

    if (isMobile) {
      $("#reco-products-slider").show();
      $("#reco-samples-slider").hide();
      $("#drawer__cart--exta-infos #product-reco--container").hide();
      $("#product-echantillons--container").show();
      $(".reco--mobile--wrapper").show();
      $("#title-extra-desktop").hide();
      $("#title-extra-mobile").show();
    } else {
      $("#reco-products-slider").hide();
      $("#reco-samples-slider").show();
      $("#drawer__cart--exta-infos #product-reco--container").show();
      $("#product-echantillons--container").hide();
      $("#title-extra-desktop").show();
      $("#title-extra-mobile").hide();
      //$('#reco-products-slider, #reco-samples-slider, #product-echantillons--container').show();
    }

    $(".slick-arrow--right").click();
  };

  var renderCart = function renderCart() {
    var url = "/cart?view=sidecart&timestamp=" + Date.now();
    var urlReco = "/cart?view=reco-products&timestamp=" + Date.now();

    // if (window.location.pathname.indexOf('cart') > -1) {
    //   url = '/cart?view=page&timestamp=' + Date.now();
    //   urlReco = '';
    // }

    $.ajax({
      type: "GET",
      url: url,
      success: function success(content) {
        var newCart = content;
        $(".cart__items__and__header--container").remove();
        $(".cart--body").append(newCart);
      },
      error: function error(_error5) {
        console.log("erreur");
      },
    });

    $.ajax({
      type: "GET",
      url: urlReco,
      success: function success(content) {
        var newCart = content;
        $(".reco__lateral--products").remove();
        $("#reco__lateral--container").append(newCart);
        var doc = new DOMParser().parseFromString(newCart, "text/html");
        var nodes = doc.body.querySelectorAll(".carousel-cell");
        $("#reco-products-slider-content").children = nodes;
      },
      error: function error(_error6) {
        console.log("erreur");
      },
    });
  };

 var updateCartData = debounce(function(total) {
  $.ajax({
    type: "GET",
    url: "/cart",
    dataType: "json",
    success: function success(response) {
      var total = response.total_price;
      var empty = response.item_count == 0 ? true : false;
      updateDeliveryModule();
        if (
          empty ||
          (response.item_count == 1 &&
            (response.items[0].title.indexOf("chantillon") > -1 ||
              response.items[0].price == 0))
        ) {
          $(".cart--body").addClass("empty__cart");
          $(".empty__cart--drawer").removeClass("display__none");
          $(".items--count").text(0);
          $(".cart__total--drawer").text(displayPrice(total));
          if ($("#full__cart--title").length > 0) {
            location.reload(true);
          }

          // Gestion des echantillons
          $(
            "#drawer__cart--exta-infos-nav, #samples--recap, #product-echantillons--container"
          ).hide();
          $(
            "#reco-products-slider, #reco-samples-slider, #product-echantillons--container"
          ).hide();
          $("#product-reco--container").show();
          $(".add__to__cart--sample.selected").click();
          $("#product-reco--container").show();
          $(".cart__drawer--body #product-reco--container").hide();
          $(".reco--mobile--wrapper").hide();
          $("#title-extra-desktop").show();
          $("#title-extra-mobile").hide();
        } else {
          $(".cart--body").removeClass("empty__cart");
          $(".empty__cart--drawer").addClass("display__none");
          $(".cart__total--drawer").text(displayPrice(total));
          $("#items--count").text(response.items.length);
          $(".items--count").text(response.items.length);

          // Gestion des echantillons
          $("#drawer__cart--exta-infos-nav, #samples--recap").show();
          $(".cart__drawer--body #product-reco--container").show();

          updateCartView();
        }
        $(".image-reco").show();
     },
    error: function error(_error) {
      console.log("erreur");
    }
  });
}, 500);

  updateCartData();

  $(window).resize(function () {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function () {
      $.ajax({
        type: "GET",
        url: "/cart",
        dataType: "json",
        success: function success(response) {
          var empty = response.item_count == 0 ? true : false;
          if (
            empty ||
            (response.item_count == 1 &&
              (response.items[0].title.indexOf("chantillon") > -1 ||
                response.items[0].price == 0))
          ) {
          } else {
            updateCartView();
          }
        },
        error: function error(_error7) {
          console.log("erreur");
        },
      });
    }, 250);
  });

  document.addEventListener(
    "addToCart",
    function (elem) {
      renderCart();
      updateCartData();
      document.dispatchEvent(new CustomEvent("cart:open"));
    },
    false
  );

  document.addEventListener(
    "rebuild-cart",
    function (elem) {
      renderCart();
    },
    false
  );
  ("use strict");

  var emballageCadeauVariantId = window.giftBoxvariant;
  $(".emballage__cadeau--button").on("click", function () {
    var data = { updates: {} };
    data.updates[emballageCadeauVariantId] = 1;
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function success() {
        location.reload();
      },
    });
  });
  ("use strict");

  $("#reco--link").on("click", function () {
    $(this).addClass("active");
    $("#samples--link").removeClass("active");
    $("#product-reco--container").show();
    $("#product-echantillons--container").hide();
    $(".abonnement--container").show();
  });

  $("#samples--link").on("click", function () {
    $(".abonnement--container").hide();
    $(this).addClass("active");
    $("#reco--link").removeClass("active");
    $("#product-reco--container").hide();
    $("#product-echantillons--container").show();
    $(
      ".image--banniere, .cart__item__image, .logo--shipping, .image-reco"
    ).show();
  });

  // Add to cart echantillon
  $("body").on("click", ".add__to__cart--sample", function (e) {
    e.preventDefault();
    var variant_id = $(this).attr("product-variant");
    var objUpdate = { updates: {} };
    objUpdate.updates[36976291578022] = 0;
    objUpdate.updates[36976292167846] = 0;
    objUpdate.updates[36976299442342] = 0;
    objUpdate.updates[36976301736102] = 0;
    if ($(this).hasClass("selected")) {
      $(".add__to__cart--sample .h6--body").text("Sélectionner");
      $(".add__to__cart--sample").removeClass(
        "button__plain--primary__color button__primary--no-hover-xs selected"
      );
      $(".add__to__cart--sample").addClass("button__plain--tertiary__color");
      $("#select--sample").text("À choisir");
    } else {
      $(".add__to__cart--sample .h6--body").text("Sélectionner");
      $(".add__to__cart--sample").removeClass(
        "button__plain--primary__color button__primary--no-hover-xs selected"
      );
      $(".add__to__cart--sample").addClass("button__plain--tertiary__color");
      $(this).removeClass("button__plain--tertiary__color");
      $(this).addClass(
        "button__plain--primary__color button__primary--no-hover-xs selected"
      );
      $(this).children(".h6--body").text("Sélectionné !");
      objUpdate.updates[variant_id] = 1;
      $("#select--sample").text("1/1 choisi");
      if (window.matchMedia("(max-width: 767px)").matches) {
        setTimeout(function () {
          $('.close--cart-drawer[for="drawer-reco"]').click();
        }, 700);
      }
    }

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: objUpdate,
      dataType: "json",
      success: function success(response) {},
      error: function error(_error) {
        console.log("erreur");
        console.log(_error);
      },
    });
  });
  ("use strict");
"use strict";
///DEVMAG///
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

var getCartContents = function() {
    return new Promise((resolve) => {
        $.getJSON('/cart.js', function(cart) {
            resolve(cart);
        });
    });
};

var logCartItems = async function() {
    const cart = await getCartContents();
};

$('body').on('click', '.add__to__cart--sample', function(e) {
    e.preventDefault();
    
    var variant_id = $(this).attr('product-variant');
    
    var objUpdate = { updates: {} };
    objUpdate.updates[variant_id] = 1;
    
    $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: objUpdate,
        dataType: "json",
        success: function(response) {},
        error: function(error) {}
    });
});

if (window.cart) {
    var renderFirst = 0;

    function sortTiers() {
        var tiers = (window.cart.tiers || []).slice().map(function (t) {
            return {
                threshold: Number(t.threshold) || 0,
                rewardType: t.rewardType,
                variantId: Number(t.variantId) || 0,
                title: t.title,
                wording: t.wording,
            };
        });
        tiers.sort(function (a, b) {
            return a.threshold - b.threshold;
        });
        return tiers;
    }

    /**
     * Montant utilisé pour la barre et les seuils : somme des lignes payantes.
     * Exclut les cadeaux auto (variante palier + ligne à 0€) pour ne pas faire
     * croire que le prochain palier est déjà atteint.
     */
    function cartTotalForRewardProgress(cart, tiers) {
        if (!cart) {
            return 0;
        }
        if (!cart.items || cart.items.length === 0) {
            return typeof cart.total_price === "number" ? cart.total_price : 0;
        }
        var giftIds = {};
        for (var g = 0; g < tiers.length; g++) {
            if (tiers[g].rewardType === "gift" && tiers[g].variantId > 0) {
                giftIds[String(tiers[g].variantId)] = true;
            }
        }
        var sum = 0;
        for (var i = 0; i < cart.items.length; i++) {
            var line = cart.items[i];
            var vid = String(line.variant_id);
            var lineTotal =
                typeof line.final_line_price === "number"
                    ? line.final_line_price
                    : (line.line_price || 0) * (line.quantity || 1);
            if (giftIds[vid] && lineTotal === 0) {
                continue;
            }
            sum += lineTotal;
        }
        return sum;
    }

    function buildGiftUpdates(total, tiers) {
        var updates = {};
        var byVariant = {};
        for (var i = 0; i < tiers.length; i++) {
            var t = tiers[i];
            if (t.rewardType !== "gift" || !t.variantId || t.variantId <= 0) {
                continue;
            }
            var vid = String(t.variantId);
            var ok = total >= t.threshold ? 1 : 0;
            byVariant[vid] = Math.max(byVariant[vid] || 0, ok);
        }
        for (var k in byVariant) {
            if (Object.prototype.hasOwnProperty.call(byVariant, k)) {
                updates[k] = byVariant[k];
            }
        }
        return updates;
    }

    /**
     * Remplissage aligné sur les jalons visuels (N segments égaux, un par palier).
     * Évite (total / dernier seuil) qui décale la barre par rapport aux marqueurs.
     */
    function barFillPercent(total, tiers) {
        var n = tiers.length;
        if (n === 0) {
            return 0;
        }
        var maxT = tiers[n - 1].threshold;
        if (maxT <= 0) {
            return 0;
        }
        if (total >= maxT) {
            return 100;
        }

        var segmentWidth = 100 / n;

        for (var i = 0; i < n; i++) {
            var prev = i === 0 ? 0 : tiers[i - 1].threshold;
            var next = tiers[i].threshold;
            if (total < next) {
                var span = next - prev;
                var segmentProgress = span > 0 ? (total - prev) / span : 0;
                return i * segmentWidth + segmentProgress * segmentWidth;
            }
        }
        return 100;
    }

    var ajaxCartGiftUpdates = debounce(function (updates) {
        if (Object.keys(updates).length === 0) {
            if (renderFirst > 0) {
                renderCart();
            }
            renderFirst += 1;
            return;
        }
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: { updates: updates },
            dataType: "json",
            success: function () {
                if (renderFirst > 0) {
                    renderCart();
                }
                renderFirst += 1;
            },
            error: function () {
                if (renderFirst > 0) {
                    renderCart();
                }
                renderFirst += 1;
            },
        });
    }, 1000);

    var shippingBarLogicWithCart = function (cart) {
        var tiers = sortTiers();
        var nbSteps = tiers.length;
        var total = cartTotalForRewardProgress(cart, tiers);

        if (!window.cart.deliveryModule || nbSteps === 0) {
            $("#progress__bar--remain").css("width", "0%");
            $("#free__shipping--message").hide();
            $("#remain__shipping__amount--message").hide();
            document.dispatchEvent(new CustomEvent("rebuild-cart"));
            return;
        }

        var maxT = tiers[tiers.length - 1].threshold;
        if (!maxT || maxT <= 0) {
            $("#progress__bar--remain").css("width", "0%");
            document.dispatchEvent(new CustomEvent("rebuild-cart"));
            return;
        }

        var nextIdx = -1;
        for (var j = 0; j < tiers.length; j++) {
            if (total < tiers[j].threshold) {
                nextIdx = j;
                break;
            }
        }

        var showFinal = nextIdx === -1;
        var colorBar = 0;
        var remainMoney = 0;
        var stepWords = "";

        if (showFinal) {
            colorBar = 100;
        } else {
            colorBar = barFillPercent(total, tiers);
            remainMoney = Math.max(0, (tiers[nextIdx].threshold - total) / 100);
            stepWords = tiers[nextIdx].wording || "";
        }

        ajaxCartGiftUpdates(buildGiftUpdates(total, tiers));

        $("#progress__bar--remain").css("width", colorBar + "%");

        if (showFinal) {
            $("#free__shipping--message").show();
            $("#remain__shipping__amount--message").hide();
        } else {
            $("#free__shipping--message").hide();
            $("#remain__shipping__amount--message").show();
            $(".amount__remaining").text(remainMoney + "€");
            $("#wording--gift").text(stepWords);
        }

        document.dispatchEvent(new CustomEvent("rebuild-cart"));
    };

    var initializeDeliveryModule = function () {
        $.getJSON("/cart.js", function (cart) {
            shippingBarLogicWithCart(cart);
        });

        logCartItems();
    };

    setTimeout(function () {
        initializeDeliveryModule();
    }, 1000);

    var updateDeliveryModule = function () {
        if (window.cart.deliveryModule) {
            $.getJSON("/cart.js", function (cart) {
                shippingBarLogicWithCart(cart);
            });
        }
    };
}

("use strict");
///ENDDEVMAG///

  //footer
  $(window).on("resize", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("#sidebar-accordion-footer .extended-submenu").hide();
      $("#sidebar-accordion-footer .nav__footer--title .plus__icon").show();
    } else {
      $("#sidebar-accordion-footer .extended-submenu").show();
      $(
        "#sidebar-accordion-footer .nav__footer--title .plus__icon"
      ).removeClass("opened");
      $("#sidebar-accordion-footer .nav__footer--title .plus__icon").hide();
    }
  });

  $(".button__with__loading").on("click", function () {
    $(this).children(".button--text").hide();
    $(this).children(".button--loading").css("display", "flex");
  });

  // Si go back --> on remet les boutons en mode texte
  window.addEventListener("pageshow", function (event) {
    var historyTraversal =
      event.persisted ||
      (typeof window.performance != "undefined" &&
        window.performance.navigation.type === 2);
    if (historyTraversal) {
      $(".button__with__loading").children(".button--text").show();
      $(".button__with__loading")
        .children(".button--loading")
        .css("display", "none");
    }
  });

  $(".form--to-validate .form-field").on("invalid", function () {
    $(".form--to-validate .button--text").show();
    $(".form--to-validate .button--loading").css("display", "none");
  });

  $("#actifs--link").on("click", function () {
    var id = $(this).attr("anchor");

    $("html, body").animate(
      {
        scrollTop: $(id).offset().top - 70,
      },
      500
    );
  });
  ("use strict");

  $("#go-top").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500
    );
  });

  if ($(document).scrollTop() > 20) {
    $("#go-top").show();
  } else {
    $("#go-top").hide();
  }

  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      $("#go-top").show();
    } else {
      $("#go-top").hide();
    }
  });
  ("use strict");

  var displayPrice = function displayPrice(price) {
    return price / 100 + "€";
  };
  ("use strict");

  $("#newsletter--homepage, #newsletter--blog, #newsletter--whitebook").submit(
    function (e) {
      e.preventDefault();
      var index = $(this).attr("form-index");
      var email = $('.email--newsletter[form-index="' + index + '"]')
        .val()
        .toLowerCase();
      var newsletterFor = $(this).attr("newsletter-for");
      var fields = "$source,$email,$consent,Accepts Marketing";
      var redirect_url;
      //var success_window = window.open();
      var formData = {
        g: $('.list--newsletter[form-index="' + index + '"]').val(),
        $fields: fields,
        email: email,
        $source: $('.newsletter-form[form-index="' + index + '"]').attr(
          "source"
        ),
        $consent: "email",
        "Accepts Marketing": true,
      };

      if (newsletterFor == "blog") {
        formData["Accepts Marketing Blog"] = true;
        fields = fields + ",Accepts Marketing Blog";
        formData["$fields"] = fields;
      }

      if (newsletterFor == "whitebook") {
        redirect_url = $('input[name="book--url"]').val();
        var firstname = $('.firstname--newsletter[form-index="' + index + '"]')
          .val()
          .toLowerCase();
        formData["$first_name"] = firstname;
        fields = fields + ",$first_name";
        formData["$fields"] = fields;
        if (!_learnq.isIdentified(email)) {
          _learnq.push(["identify", { $email: email, $first_name: firstname }]);
        } else {
          _learnq.pop();
          _learnq.push(["identify", { $email: email, $first_name: firstname }]);
        }
      }

      $.ajax({
        type: "POST",
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        data: formData,
        dataType: "json",
        success: function success(response) {
          if (response.errors && response.errors.length > 0) {
            $(".newsletter-form .error--email").show();
            _learnq.push([
              "identify",
              {
                $email: email,
                $first_name: firstname,
              },
            ]);
            success_window.close();
          } else {
            $(".newsletter-hp .intro .first").hide();
            $(".newsletter-hp .intro--text").hide();
            $("#newsletter--homepage").hide();
            $(".newsletter-hp .intro .success").show();
            if (newsletterFor == "whitebook") {
              var delayInMilliseconds = 4000;
              setTimeout(function () {
                _learnq.push([
                  "track",
                  "Inscription livre blanc",
                  { $email: email },
                ]);
                success_window.location = redirect_url;
              }, delayInMilliseconds);
            }
          }
        },
        error: function error(_error) {
          $(".newsletter-form .error--email").show();
        },
      });
    }
  );
  ("use strict");

  if (window.collection) {
    var selectedInput = $(
      '.select__custom--value[value="' + window.collection.defaultSortBy + '"]'
    )
      .first()
      .text();

    $(
      '.select__custom--value[value="' + window.collection.defaultSortBy + '"]'
    ).addClass("is__active");

    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".select__custom--selected-value").text(selectedInput);
    }
  }
  ("use strict");

  // Filters
  $(".filter__group--title").on("click", function () {
    // Fermture des autres filtres
    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".filter__group--item-list").slideUp(300);
    }
    $(".icon--arrow-bottom").removeClass("opened");
    if ($(this).hasClass("opened")) {
      $(this).removeClass("opened");
      $(this)
        .children(".filter__section--title")
        .children(".icon--arrow-bottom")
        .removeClass("opened");
    } else {
      $(this)
        .children(".filter__section--title")
        .children(".icon--arrow-bottom")
        .toggleClass("opened");
      $(this).siblings(".filter__group--item-list").slideToggle(300);
      $(".filter__group--title").removeClass("opened");
      $(this).toggleClass("opened");
    }
  });

  $("body").on("click", ".reinitialize__filters", function () {
    window.collection.currentFilters = [];
    $(".reinitialize__filters").hide();
    $(".filter__item--mini").remove();
    $(".filter__button").removeClass("is__active");
    var filteredUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.collection.collectionUrl +
      "?sort_by=" +
      window.collection.sortBy;
    if (history.replaceState) {
      window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
    }
    $.ajax({
      type: "GET",
      url: filteredUrl + "&view=filtered",
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $(".filter-count").text(count);
        $("#collection__list--container").remove();
        $("#collection__page--desktop").append(content.substring(4));
        $(".close[for=drawer-filter]").click();
      },
      error: function error(_error) {
        console.log("erreur");
      },
    });
  });

  $("body").on("click", ".filter__item--mini", function () {
    var filter_value = $(this).attr("filter-value-handle");
    $(".filter__item--mini[filter-value-handle=" + filter_value + "]").remove();
    $(".filter__button[filter-value-handle=" + filter_value + "]")[0].click();
  });

  $(".filter__group--title.active--group").click();

  $("body").on("click", ".filter__button", function () {
    var mini__filter = window.collection.miniFilter;
    var filter_value = $(this).attr("filter-value-handle"),
      filteredUrl = "";
    var filtersList = window.collection.currentFilters;
    var group = $(this).attr("filter-group");

    // Gestion de laccordeon
    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".filter__group--item-list").slideUp(300);
      $(".icon--arrow-bottom").removeClass("opened");
    }
    $(".filter__group--title").removeClass("opened");

    if ($(this).hasClass("is__active")) {
      $(
        ".filter__button[filter-value-handle=" + filter_value + "]"
      ).removeClass("is__active");

      filtersList.splice(filtersList.indexOf(filter_value), 1);

      window.collection.currentFilters = filtersList;
      window.collection.currentFilters.sort();

      $(
        ".filter__item--mini[filter-value-handle=" + filter_value + "]"
      ).remove();
    } else {
      // Supprime les tags du meme groupe deja actifs
      var group = filter_value.split("_")[0];
      $('.filter__button[filter-group-handle="' + group + '"]').removeClass(
        "is__active"
      );
      $(".filter__button[filter-value-handle=" + filter_value + "]").addClass(
        "is__active"
      );

      $('.filter__item--mini[filter-group-handle="' + group + '"]').remove();

      for (var i = 0; i < filtersList.length; i++) {
        if (filtersList[i].indexOf(group) > -1) {
          filtersList.splice(i, 1);
        }
      }

      window.collection.currentFilters = filtersList;
      window.collection.currentFilters.push(filter_value);
      window.collection.currentFilters.sort();

      $(".filter__values--list").append(
        '<li class="filter__item--mini h5--body white fw--600 text__uppercase mh--10 margin__left--none" filter-value-handle="' +
          filter_value +
          '" filter-group-handle="' +
          group +
          '"><span>' +
          $(this).attr("filter-value") +
          '</span><span class="close close__filter"></span></li>'
      );
    }

    if (window.collection.currentFilters.length > 0) {
      $(".reinitialize__filters").show();
      filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "/" +
        window.collection.currentFilters.join("+") +
        "?sort_by=" +
        window.collection.sortBy;
    } else {
      $(".reinitialize__filters").hide();
      filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?sort_by=" +
        window.collection.sortBy;
    }

    if (history.replaceState) {
      window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
    }

    $.ajax({
      type: "GET",
      url: filteredUrl + "&view=filtered",
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $(".filter-count").text(count);
        $("#collection__list--container").remove();
        $("#collection__page--desktop").append(content.substring(4));
      },
      error: function error(_error2) {
        console.log("erreur");
      },
    });
  });

  // mobile
  $(".action--button-validate").on("click", function (e) {
    e.preventDefault();
    $("#navigation__drawer--header .close").click();
  });
  $(".action--button-close").on("click", function (e) {
    e.preventDefault();
    $("#navigation__drawer--header .close").click();
  });
  ("use strict");

  $(".product__item__link--container").on("click", function (e) {
    e.preventDefault();
    if ($(e.target).is(".property--item")) {
      var url = $(e.target).attr("link");
      window.location.href = url;
    } else {
      window.location = this.href;
    }
  });
  ("use strict");

  function updateProductButtonQuickAdd(variant) {
    $(".add__to__cart--quick-add").attr("variant-id", variant.id);

    if (variant.available == false) {
      $(".add__to__cart--quick-add").html(
        '<span class="text__center fw--700 tertiary__color main__title--blog-categories ">\n          Rupture de stock\n        </span>'
      );
      $(".add__to__cart--quick-add").attr("variant-available", "false");
    } else {
      $(".add__to__cart--quick-add").html(
        '<span class="text__center fw--700 tertiary__color main__title--blog-categories">Ajouter au panier\n    <span class="ph--5">-</span>\n    <span class="product--price">' +
          displayPrice(variant.price) +
          "</span>"
      );
      $(".add__to__cart--quick-add").attr("variant-available", "true");
      $(".add__to__cart--quick-add").attr("id", "");
    }
  }

  function onOptionChangedQuickAdd() {
    var productOptions = [];
    for (var i = 1; i <= 3; i++) {
      productOptions[i - 1] =
        $(
          '#product-grid-modal .select__custom--selected-value[name="product__option--' +
            i +
            '"]'
        )
          .text()
          .trim() || "";
    }
    if (
      window.productGridDetails &&
      window.productGridDetails.variants.length > 1
    ) {
      window.productGridDetails.variants.forEach(function (variant) {
        if (
          variant.option1 == productOptions[0] &&
          (variant.option2 == productOptions[1] || variant.option2 == null) &&
          (variant.option3 == productOptions[2] || variant.option3 == null)
        ) {
          $("#product-grid-modal .featured--img").attr(
            "src",
            variant.featured_media.preview_image.src
          );
          $("#product-grid-modal .product--price").text(
            displayPrice(variant.price)
          );
          if (variant.compare_at_price > variant.price) {
            $("#product-grid-modal .product--compare-at-price").text(
              displayPrice(variant.compare_at_price)
            );
            var percentagePromo =
              "- " +
              Math.floor(
                ((parseInt(variant.compare_at_price) -
                  parseInt(variant.price)) /
                  parseInt(variant.compare_at_price)) *
                  100
              ) +
              "%";
            $("#product-grid-modal .body__text--collection-promo").text(
              percentagePromo
            );
            $("#product-grid-modal .sales__tag--container").show();
          } else {
            $("#product-grid-modal .product--compare-at-price").text("");
            $("#product-grid-modal .sales__tag--container").hide();
          }

          updateProductButtonQuickAdd(variant);
        }
      });
    }
  }

  ("use strict");

  $(".faq__q__and__a").on("click", function () {
    $(".arrow-bottom").attr("arrow-open", "false");
    var $question = $(this).children(".faq__question");
    $(".plus__icon").removeClass("opened");
    $question.children(".plus__icon").toggleClass("opened");
    if ($question.next().attr("aria-hidden") == "false") {
      $question.next().slideToggle(200).attr("aria-hidden", "true");
      $(this).find("span").attr("arrow-open", "false");
      $(".plus__icon").removeClass("opened");
    } else {
      $(".faq__q__and__a")
        .find('.faq__answer[aria-hidden="false"]')
        .not($question)
        .slideToggle(200)
        .attr("aria-hidden", "true");
      $question.next().slideToggle(200).attr("aria-hidden", "false");
      $(this).find("span").attr("arrow-open", "true");
    }
  });

  $(".question").on("click", function () {
    $(".arrow-bottom").attr("arrow-open", "false");
    if ($(this).next().attr("aria-hidden") == "false") {
      $(this).next().slideToggle(200).attr("aria-hidden", "true");
      $(this).find("span").attr("arrow-open", "false");
    } else {
      $(".faq--container")
        .find('.faq__answer[aria-hidden="false"]')
        .not(this)
        .slideToggle(200)
        .attr("aria-hidden", "true");
      $(this).next().slideToggle(200).attr("aria-hidden", "false");
      $(this).find("span").attr("arrow-open", "true");
    }
  });

  // faq2.liquid
  $(".title-link__container").on("click", function () {
    var number = $(this).attr("data-separator");
    $(".title-link__container").removeClass("is-active");
    $(this).addClass("is-active");
    $(".questions__container.is-opened").removeClass("is-opened is-visible");
    $(".questions__container[data-separator=" + number + "]").addClass(
      "is-opened"
    );
    setTimeout(function () {
      $(".questions__container[data-separator=" + number + "]").addClass(
        "is-visible"
      );
    }, 10);
  });
  ("use strict");

  // Documentation
  // https://flickity.metafizzy.co/options.html

  // groupCells: 4, --> to group cells
  // pageDots: false --> pagination
  // prevNextButtons --> remove arrow
  // autoPlay: 1500 --> autoplay with duration
  // fade: true --> fade instead of slide
  // wrapAround: true --> infinite loop
  var arrowShape =
    "M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z";
  var carousel = $(".background-slider");
  carousel.flickity();

  var blogSlider = $(".blog-slider");
  blogSlider.flickity();

  // Flickity bandeau
  // ===============================================
  var myFlickityBandeau = undefined;

  function initFlickityBandeau() {
    if (
      window.matchMedia("(max-width: 949px)").matches &&
      myFlickityBandeau == undefined
    ) {
      myFlickityBandeau = $("#bandeau--footer-slider");
      myFlickityBandeau.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
      });
    } else if (
      window.matchMedia("(min-width: 950px)").matches &&
      myFlickityBandeau != undefined
    ) {
      myFlickityBandeau.flickity("destroy");
      myFlickityBandeau = undefined;
    }
  }

  $(window).on("resize", function () {
    initFlickityBandeau();
  });
  initFlickityBandeau();

  /*============================================================================
  #Slider Avis Homepage
==============================================================================*/

  function initFlickityAvis() {
    var myFlickityAvisClient = $(".slider__avis--clients");
    myFlickityAvisClient.flickity({
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      arrowShape:
        "M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z",
      contain: true,
      cellAlign: "left",
    });
  }

  initFlickityAvis();
  $(window).on("resize", function () {
    initFlickityAvis();
  });

  /*============================================================================
  #Slider Soin par type de peau Homepage
==============================================================================*/
  function initFlickitySoins() {
    var myFlickitySoin = $(".slider__type-peau");
    myFlickitySoin.flickity({
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      cellAlign: "left",
    });
  }

  initFlickitySoins();
  $(window).on("resize", function () {
    initFlickitySoins();
  });

  /*============================================================================
  #Slider banniere texte
==============================================================================*/
  function initFlickityBanniere() {
    var myFlickityBanniereHome = $(".slider--banniere-auto");
    myFlickityBanniereHome.flickity({
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      cellAlign: "left",
      autoPlay: true,
    });
  }

  initFlickityBanniere();
  $(window).on("resize", function () {
    initFlickityBanniere();
  });

  /*============================================================================
  #Slider Routine page produit
==============================================================================*/
  function initFlickityRoutine() {
    var myFlickityRoutine = $(".slider__routine");
    myFlickityRoutine.flickity({
      wrapAround: true,
      prevNextButtons: true,
      arrowShape: arrowShape,
      pageDots: false,
      contain: true,
      cellAlign: "left",
    });
  }

  initFlickityRoutine();
  $(window).on("resize", function () {
    initFlickityRoutine();
  });

  $(".product--list").slick();
  ("use strict");

  // Ouvrir la modal au clic

  $(document).on("click", ".button__action", function (e) {
    e.preventDefault();

    var buttonFor = $(this).attr("for");
    var selector = $(this).attr("open-selector");

    if (selector == "#navigation__drawer" || selector == "#filter__drawer") {
      $(selector).addClass("opened");
    } else if (buttonFor == "accordeon") {
    } else {
      $(selector).addClass("opened");
      $("#page__overlay").addClass("opened");
    }

    if (buttonFor == "modal" && selector) {
      $("#page__overlay").attr("for", "modal");
    } else if (buttonFor == "drawer-menu" && selector) {
      $(
        ".image--banniere, .cart__item__image, .logo--shipping, .image-reco"
      ).show();
      if (window.matchMedia("(max-width: 768px)").matches) {
        if ($(document).scrollTop() < 20) {
          $("html, body").css({ overflow: "hidden" });
        }
      }
      $(this).addClass("change close").removeClass("button__action");
    } else if (buttonFor == "drawer" && selector) {
      $("#page__overlay").attr("for", "drawer");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "hidden" });
      }
    } else if (buttonFor == "drawer-cart" && selector) {
      $(".image-reco, .cart__item__image, .logo--shipping, .image-reco").show();
      $(".menu.close").click();
      $("#page__overlay").attr("for", "drawer");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "hidden" });
      }
      if (window.matchMedia("(min-width: 1001px)").matches) {
        setTimeout(function () {
          $("#drawer__cart--exta-infos").addClass("opened");
        }, 350);
      }
      document.dispatchEvent(new CustomEvent("cart:open"));
    } else if (buttonFor == "drawer-filter" && selector) {
      $("#filter__drawer").addClass("opened");
      $("#MainContent.transparent--nav").css("transform", "inherit");
      $(".supports-no-cookies").css("overflow", "hidden");
    } else if (buttonFor == "drawer-reco" && selector) {
      $("#reco--link").click();
      $("#drawer__cart--exta-infos").addClass("opened");
    } else if (buttonFor == "drawer-sample" && selector) {
      $("#samples--link").click();
      $("#drawer__cart--exta-infos").addClass("opened");
    } else if (buttonFor == "accordeon") {
      var isActive = false;
      if ($(this).hasClass("active")) {
        isActive = true;
      }
      if ($(this).hasClass("link--item-button")) {
        $(".link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".link--item-button.active").removeClass("active");
      } else if ($(this).hasClass("sub__link--item-button")) {
        $(".sub__link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".sub__link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".sub__link--item-button.active").removeClass("active");
      }

      if (isActive == false) {
        $(this).toggleClass("active");
        $(this).children(".plus__icon").toggleClass("opened");
        $(this)
          .siblings(".accordeon__list")
          .addClass("opened")
          .slideToggle("500");
      }
    }
    if (buttonFor == "select" && selector) {
      $("#page__overlay").attr("for", "select");
    }
  });

  // Fermer la modal au clic sur la croix
  $(document).on("click", ".close, .close--button", function (e) {
    e.preventDefault();
    var closeFor = $(this).attr("for");

    if (
      closeFor == "drawer-shipping" ||
      closeFor == "drawer-reco" ||
      closeFor == "drawer-sample"
    ) {
    } else {
      $("#page__overlay").removeClass("opened");
      $("#page__overlay").attr("for", "");
    }

    if (closeFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    } else if (closeFor == "drawer") {
      $(".drawer").removeClass("opened");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "visible" });
      }
    } else if (closeFor == "drawer-cart") {
      $(".drawer-cart").removeClass("opened");
      $(".drawer").removeClass("opened");
      $(".drawer-reco").removeClass("opened");
      $(".drawer-shipping").removeClass("opened");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "visible" });
      }
    } else if (closeFor == "drawer-filter") {
      $(".drawer-filter").removeClass("opened");
      $(".supports-no-cookies").css("overflow", "");
      setTimeout(function () {
        if (window.matchMedia("(max-width: 1100px)").matches) {
          $("#MainContent.transparent--nav").css(
            "transform",
            "translateY(0px)"
          );
        } else {
          $("#MainContent.transparent--nav").css(
            "transform",
            "translateY(-70px)"
          );
        }
      }, 500);
    } else if (closeFor == "drawer-shipping") {
      $(".drawer-shipping").removeClass("opened");
    } else if (closeFor == "drawer-reco") {
      $(".drawer-reco").removeClass("opened");
    } else if (closeFor == "drawer-menu") {
      $(".drawer").removeClass("opened");
      $(this).removeClass("change close").addClass("button__action");

      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "visible" });
      }
    } else if (closeFor == "select") {
      $(".select").removeClass("opened");
    }
  });

  // Clic en dehors de la'modal'
  $("#page__overlay").on("click", function (e) {
    e.preventDefault();
    var overlayFor = $(this).attr("for");

    $(this).removeClass("opened");
    $("#page__overlay").attr("for", "");

    if (overlayFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    } else if (overlayFor == "drawer") {
      $(".drawer").removeClass("opened");
      $(".drawer-cart").removeClass("opened");
      $(".drawer-shipping").removeClass("opened");
      $(".drawer-reco").removeClass("opened");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "visible" });
      }
    } else if (overlayFor == "select") {
      $(".select").removeClass("opened");
    }
  });

  // Ajout de la variant lors de la selection + Fermer modal
  $(".variant__select").on("click", function (e) {
    //$('#iddeclasse').attr('variant', $(this).attr("value"));
    e.preventDefault();
    $(".select").removeClass("opened");
    var closeFor = $(this).attr("for");
    $("#page__overlay").removeClass("opened");
    $("#page__overlay").attr("for", "");
  });

  $("#page__overlay--white").on("click", function (e) {
    e.preventDefault();
    $(this).removeClass("opened");
    $(".select__custom--values").hide();
    $(".select__custom--values").removeClass("opened");
  });

  $("#page__overlay--white-quick-add").on("click", function (e) {
    e.preventDefault();
    $(this).removeClass("opened");
    $("#product-grid-modal .select__custom--values").hide();
    $("#product-grid-modal .select__custom--values").removeClass("opened");
  });
  ("use strict");
  ("use strict");

  // Click sur le select
  $("body").on(
    "click",
    ".select__custom--selected-value-container",
    function (e) {
      var forSelect = $(this).attr("for");
      $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50);
      $('.select__custom--values[for="' + forSelect + '"]').addClass("opened");
      $("#page__overlay--white").addClass("opened");
      if ($("#product-grid-modal.opened").length > 0) {
        $("#page__overlay--white-quick-add").addClass("opened");
      }
    }
  );

  $("body").on("click", ".select__custom--value", function (e) {
    var forSelect = $(this).attr("for");
    var value = $(this).attr("value");
    var valueText = $(this).text();
    //est ce quon a modifie un select via quick view
    var quickAdd = $(this).attr("product-grid") || "false";

    $('.select__custom--value[for="' + forSelect + '"]').removeClass(
      "is__active"
    );
    $(this).addClass("is__active");
    $('.select__custom--selected-value[name="' + forSelect + '"]').text(
      valueText
    );
    $('.select__hidden[for="' + forSelect + '"]')
      .val(value)
      .trigger("change");
    $(".select__custom--values").hide();
    $(".select__custom--values").removeClass("opened");
    $("#page__overlay--white").removeClass("opened");
    $("#page__overlay--white-quick-add").removeClass("opened");
    document.dispatchEvent(
      new CustomEvent("select-changed:" + forSelect, {
        detail: { quickAdd: quickAdd },
      })
    );
  });

  // document.addEventListener('select-changed:sort--by', function (elem) {
  // }, false);

  // Sort
  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $('.select__hidden[for="sort--by"]').bind("change", function () {
    Shopify.queryParams.sort_by = $(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
  });
  ("use strict");

  var announcementDetails = {};
  if ($("[announcement-details]").html()) {
    announcementDetails = JSON.parse($("[announcement-details]").html());
  }

  var text_ecran = announcementDetails.text_ecran;
  var text_mobile = announcementDetails.text_mobile;
  var lien_ecran = announcementDetails.lien_ecran;
  var lien_mobile = announcementDetails.lien_mobile;
  var counter = 1;
  var elem = $("#annonce");

  if (window.matchMedia("(min-width: 767px)").matches) {
    var change = function change() {
      if (text_ecran && text_ecran.length > 1) {
        elem.fadeOut(function () {
          elem.html(text_ecran[counter]);
          if (lien_ecran[counter] != "unlink") {
            elem.attr("href", lien_ecran[counter]);
          } else {
            elem.removeAttr("href");
          }
          counter++;
          if (counter >= text_ecran.length) {
            counter = 0;
          }
          elem.fadeIn();
        });
      }
    };

    if (lien_ecran && lien_ecran[0] && lien_ecran[0] != "unlink") {
      elem.attr("href", lien_ecran[0]);
    } else {
      elem.removeAttr("href");
    }
    setInterval(change, 6000);
  } else {
    var _change = function _change() {
      if (text_mobile && text_mobile.length > 1) {
        elem.fadeOut(function () {
          elem.html(text_mobile[counter]);
          if (lien_mobile[counter] != "unlink") {
            elem.attr("href", lien_mobile[counter]);
          } else {
            elem.removeAttr("href");
          }
          counter++;
          if (counter >= text_mobile.length) {
            counter = 0;
          }
          elem.fadeIn();
        });
      }
    };

    if (lien_mobile && lien_mobile[0] && lien_mobile[0] != "unlink") {
      elem.attr("href", lien_mobile[0]);
    } else {
      elem.removeAttr("href");
    }

    text_mobile ? elem.html(text_mobile[0]) : null;
    setInterval(_change, 3000);
  }
  ("use strict");

  if (window.matchMedia("(max-width: 767px)").matches) {
    $("#sidebar-accordion-footer .plus__icon").show();
    $("#sidebar-accordion-footer")
      .find("li.extend")
      .click(function (e) {
        $(this).children(".extended-submenu").slideToggle("fast");
        $(this)
          .children(".nav__footer--title")
          .children(".plus__icon")
          .toggleClass("opened");
        $(this).toggleClass("active");
      });
  }
  ("use strict");

  var pageOverlayOpened = false;
  $("body").on(
    "mouseenter",
    ".navigation__item--link-megamenu:not(.search--opened)",
    function () {
      if (pageOverlayOpened == false) {
        $("#page__overlay--navigation").addClass("opened");
        pageOverlayOpened = true;
      }
    }
  );

  $("body").on(
    "mouseleave",
    ".navigation__item--link-megamenu:not(.search--opened)",
    function () {
      if (pageOverlayOpened == true) {
        $("#page__overlay--navigation").removeClass("opened");
        pageOverlayOpened = false;
      }
    }
  );
  ("use strict");

  var whiteNavBar = function whiteNavBar() {
    $("#main__logo--svg").removeClass("logo--white");
    $(".link--text-style").removeClass("white");
    $("#icon-account .icon--compte").removeClass("logo--white");
    $("#icon-cart .icon--panier").removeClass("logo--white");
    $("#icon-cart .items--count").removeClass("white");
    $("#icon-search .icon--recherche").removeClass("logo--white");
    $("#icon-underline .icon--soulignement").removeClass("logo--white");
  };

  var transparentNavbar = function transparentNavbar() {
    $("#main__logo--svg").addClass("logo--white");
    $(".link--text-style").addClass("white");
    $("#icon-account .icon--compte").addClass("logo--white");
    $("#icon-cart .icon--panier").addClass("logo--white");
    $("#icon-cart .items--count").addClass("white");
    $("#icon-search .icon--recherche").addClass("logo--white");
    $("#icon-underline .icon--soulignement").addClass("logo--white");
  };

  var handleBarChange = function handleBarChange() {
    if ($("#navigation--container").hasClass("fixedWhiteNav") == false) {
      $("#navigation--container").addClass("transparent--nav");
      transparentNavbar();
    }
  };

  if (
    window.location.pathname == "/" ||
    window.general.headerTransparent == 1
  ) {
    if (window.location.href.indexOf("product") > -1) {
      if (window.matchMedia("(min-width: 1101px)").matches) {
        if ($(document).scrollTop() < 20) {
          if ($("#navigation--container").hasClass("fixedWhiteNav") == false) {
            $("#navigation--container").addClass("transparent--nav");
          }
          $("#navigation--container").mouseenter(function () {
            $(this).removeClass("transparent--nav");
          });

          $("#navigation--container").mouseleave(function () {
            if (
              $("#navigation--container").hasClass("fixedWhiteNav") == false
            ) {
              $("#navigation--container").addClass("transparent--nav");
            }
          });
        }

        if ($(document).scrollTop() > 20) {
          $("#navigation--container").removeClass("transparent--nav");
          $("#navigation--container").addClass("scrolled--nav");
        }

        $(document).on("scroll", function () {
          if ($(document).scrollTop() > 20) {
            $("#navigation--container").removeClass("transparent--nav");
            $("#navigation--container").addClass("scrolled--nav");
          } else {
            if (
              $("#navigation--container").hasClass("fixedWhiteNav") == false
            ) {
              $("#navigation--container").addClass("transparent--nav");
            }
            $("#navigation--container").removeClass("scrolled--nav");

            $("#navigation--container").mouseleave(function () {
              if (
                $("#navigation--container").hasClass("fixedWhiteNav") == false
              ) {
                $("#navigation--container").addClass("transparent--nav");
              }
            });
          }
        });
      }
    } else {
      if (window.matchMedia("(min-width: 1101px)").matches) {
        if ($(document).scrollTop() < 20) {
          if ($("#navigation--container").hasClass("fixedWhiteNav") == false) {
            $("#navigation--container").addClass("transparent--nav");
          }
          $("#navigation--container").mouseenter(function () {
            $(this).removeClass("transparent--nav");
            whiteNavBar();
          });

          $("#navigation--container").mouseleave(function () {
            handleBarChange();
          });
        } else {
          $("#navigation--container").removeClass("transparent--nav");
          $("#navigation--container").addClass("scrolled--nav");
          whiteNavBar();
        }

        $(document).on("scroll", function () {
          if ($(document).scrollTop() > 20) {
            $("#navigation--container").removeClass("transparent--nav");
            $("#navigation--container").addClass("scrolled--nav");
            whiteNavBar();

            $("#navigation--container").mouseleave(function () {
              whiteNavBar();
            });
          } else {
            handleBarChange();

            $("#navigation--container").removeClass("scrolled--nav");
            $("#navigation--container").mouseleave(function () {
              handleBarChange();
            });
          }
        });
      }
    }
  }

  // Gestion de la hauteur du drawer sur mobile
  // a utiliser si le drawer ne fait pas 100% de l'ecran
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 40;
  } else {
    var navbarHeightMobile = 74;
  }
  $("#navigation__drawer").css(
    "height",
    window.innerHeight - navbarHeightMobile
  ); // init
  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      var navbarHeightMobile = 40;
    } else {
      var navbarHeightMobile = 74;
    }
    $("#navigation__drawer").css(
      "height",
      window.innerHeight - navbarHeightMobile
    );
  });

  // Gestion du scroll
  if (window.matchMedia("(max-width: 1100px)").matches) {
    if ($(document).scrollTop() > 20) {
      $("#navigation__drawer").addClass("scroll-drawer");
    } else {
      $("#navigation__drawer").removeClass("scroll-drawer");
    }
    $(document).on("scroll", function () {
      if ($(document).scrollTop() > 20) {
        $("#navigation__drawer").addClass("scroll-drawer");
      } else {
        $("#navigation__drawer").removeClass("scroll-drawer");
      }
    });
  }
  ("use strict");

  if (
    window.location.href.indexOf("blog") > -1 ||
    window.location.href.indexOf("article") > -1
  ) {
    $("#icon-search-blog, #icon-search-blog-2").on("click", function () {
      if ($(".search--container").hasClass("opened-blog")) {
        $(".search--container").removeClass("opened-blog");
        $(".searchArticle").val("");
        $(".result-search").html("");
      } else {
        $(".search--container").addClass("opened-blog");
      }
    });

    var handleCloseSearch = function handleCloseSearch() {
      $(".searchArticle").val("");
      $(".result-search").html("");
      $(".search--container").removeClass("opened-blog");
      $(".search--container").css("transform", "");
    };

    $(".close--search").on("click", function () {
      handleCloseSearch();
    });

    $(document).on("click", function (e) {
      var container = $(".search--container");
      var container2 = $(".search--container-barre");
      if ($(e.target).hasClass("search--trigger")) {
      } else {
        if (
          container.hasClass("opened-blog") &&
          !container.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          handleCloseSearch();
        }
      }

      if (!container2.is(e.target) && container2.has(e.target).length === 0) {
        $(".searchArticle-barre").val("");
        $(".result-search-barre").html("");
      }
    });
  } else {
    var handleSearchBar = function handleSearchBar(
      searchTriggerId,
      positionScrolledClass,
      positionClass,
      translateYScrolled,
      translateY
    ) {
      $(searchTriggerId).on("click", function () {
        if (
          $(".search--container").hasClass(positionScrolledClass) ||
          $(".search--container").hasClass(positionClass)
        ) {
          $("#page__overlay--navigation").removeClass("opened");
          $(".navigation__item--container").removeClass("search--opened");
          $("#navigation--container").removeClass("fixedWhiteNav");
          $(".search--container").removeClass(
            positionScrolledClass + " " + positionClass
          );
          $(".search--container").css("transform", "");
          $(".searchProduct").val("");
          $(".result-search").html("");
          $(".popular_product").hide();
        } else {
          $("#page__overlay--navigation").addClass("opened");
          $(".navigation__item--container").addClass("search--opened");
          $("#navigation--container").addClass("fixedWhiteNav");
          $("#navigation--container").removeClass("transparent--nav");
          $(".popular_product").show();
          if ($(document).scrollTop() >= 20) {
            $(".search--container").addClass(positionScrolledClass);
          } else {
            var topPosition = translateY - $(document).scrollTop();
            $(".search--container").addClass(positionClass);
            $(
              ".search--container." +
                positionClass +
                ", .search--container." +
                positionScrolledClass
            ).css("transform", "translateY(" + topPosition + "px)");
          }
        }
        $(".searchProduct.search--input").focus();
      });

      $(document).on("scroll", function () {
        if ($(document).scrollTop() >= 20) {
          $(
            ".search--container." +
              positionClass +
              ", .search--container." +
              positionScrolledClass
          ).css("transform", "translateY(" + translateYScrolled + "px)");
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $(
            ".search--container." +
              positionClass +
              ", .search--container." +
              positionScrolledClass
          ).css("transform", "translateY(" + topPosition + "px)");
        }
      });
    };

    if (window.matchMedia("(max-width: 767px)").matches) {
      handleSearchBar(
        "#icon-search-mobile",
        "opened-mobile-scroll",
        "opened-mobile2",
        280,
        310
      );
    } else if (window.matchMedia("(max-width: 1100px)").matches) {
      handleSearchBar(
        "#icon-search-mobile",
        "opened-mobile-scroll",
        "opened-mobile",
        280,
        315
      );
    } else {
      handleSearchBar("#icon-search", "opened-scroll", "opened", 270, 305);
    }

    var handleCloseSearch = function handleCloseSearch() {
      $(".searchProduct").val("");
      $(".result-search").html("");
      $(".search--container").removeClass(
        "opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2"
      );
      $(".search--container").css("transform", "");
      $("#navigation--container").removeClass("fixedWhiteNav");
      $("#page__overlay--navigation").removeClass("opened");
      $(".navigation__item--container").removeClass("search--opened");
    };

    $(".close--search").on("click", function () {
      handleCloseSearch();
    });

    $(document).on("click", function (e) {
      var container = $(".search--container");
      if ($(e.target).hasClass("search--trigger")) {
      } else {
        if (
          (container.hasClass("opened") ||
            container.hasClass("opened-mobile")) &&
          !container.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          handleCloseSearch();
        }
      }
    });

    $(document).on("click", ".global-search", function () {
      //var url = window.location.hostname
      var search = document.getElementsByClassName("searchProduct")[0].value;
      var redirection = "/search?type=product&q=" + search;
      window.location.replace(redirection);
      $(".search--container").removeClass("opened");
    });
  }

  $(document).on("input", ".search--input", function () {
    if ($(this).attr("search") === "barre") {
      SearchFunction("searchArticle-barre", "article", "result-search-barre");
    } else if ($(this).attr("search") === "article") {
      SearchFunction("searchArticle", "article", "result-search");
    } else if ($(this).attr("search") === "produit") {
      SearchFunction("searchProduct", "product", "result-search");
    }
  });

  var SearchFunction = function SearchFunction(
    classInput,
    typeSearch,
    classInputResult
  ) {
    var htmlItem = function htmlItem(type, item) {
      if (type == "article") {
        return (
          "<div class='one-product'><a class='flex fd--row jc--flex-start' href=" +
          item[i].url +
          "><img class='image-product' src=" +
          item[i].image +
          "><div class='content--container flex fd--column ai--flex-start'><p class='price--grid dark__color'>" +
          item[i].title +
          "</p></div></a></div>"
        );
      } else {
        /**** SEARCH : HERE FOR CHANGING PRICE (display price_max instead of price)  ***/

        var prix = item[i].price.replace(".", ",") + "€";
        /*
                if (item[i].compare_at_price_max == 0.00) {
                    var prix = item[i].price.replace('.', ',') + '€';
                } else {
                    var prix = item[i].price.replace('.', ',') + "€<span class='reduction line__through '>" + item[i].compare_at_price_max.replace('.', ',') + "€</span>";
                }
                */
        return (
          " <div class='one-product'><a class='flex fd--row jc--flex-start' href=" +
          item[i].url +
          "><img class='image-product' src=" +
          item[i].image +
          "><div class='content--container flex fd--column ai--flex-start'><p class='title--grid dark__color' style='font-size: 14px; line-height: initial;'>" +
          item[i].type +
          "</p><p class='price--grid dark__color'>" +
          item[i].title +
          "</p><p class='price price--grid dark__color fw--700'>" +
          prix +
          "</p></div></a></div>"
        );
      }
    };

    var emptyItem = function emptyItem(type) {
      if (type == "article") {
        return "<div class='empty'>Aucun article ne correspond à votre recherche</div>";
      } else {
        return "<div class='empty'>Aucun produit ne correspond à votre recherche</div>";
      }
    };

    var q = document.getElementsByClassName(classInput)[0].value;
    var b = "&resources[type]=" + typeSearch;
    var c = "";
    if (q == "") {
      $(".result-search").html("");
      $(".result-search-barre").html("");
    }
    if (typeSearch == "article") {
      var type = "article";
    } else {
      var type = "product";
      c = "&fields=title,product_type,tag";
      if (q == "") {
        $(".popular_product").show();
      } else {
        $(".popular_product").hide();
      }
    }
    $.ajax("/search/suggest.json?q=" + q + b + c, {
      type: "GET",
      dataType: "json",
      success: function success(response) {
        var itemsSuggestions = response.resources.results[typeSearch + "s"];
        if (itemsSuggestions.length > 0) {
          var result = "";
          for (i = 0; i < itemsSuggestions.length; i++) {
            if (!itemsSuggestions[i].tags.includes("echantillon")) {
              result += htmlItem(type, itemsSuggestions);
            }
          }
          if (type == "product") {
            result =
              result + "<div class='global-search'>Plus de résultats</div>";
          }
          $("." + classInputResult).html(result);
        } else {
          var emptyProduct = emptyItem(type);
          $("." + classInputResult).html(emptyProduct);
        }
      },
    });
  };
  ("use strict");

  $(".picto__container").on("click", function () {
    var number = $(this).attr("data-separator");
    $(".picto__container").removeClass("is-active");
    $(this).addClass("is-active");
    $(".questions__container.is-opened").removeClass("is-opened is-visible");
    $(".questions__container[data-separator=" + number + "]").addClass(
      "is-opened"
    );
    setTimeout(function () {
      $(".questions__container[data-separator=" + number + "]").addClass(
        "is-visible"
      );
    }, 10);
  });
  ("use strict");

  $("#close-article-page").on("click touchend", function () {
    $("#article-page-overlay").hide();
  });
  $(document).mouseup(function (e) {
    var container = $("#article-page");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $("#article-page-overlay").hide();
    }
  });
  $(".article").on("click touchend", function () {
    var background_url = $(this).attr("background-img");
    if (typeof background_url !== "undefined" && background_url !== false) {
      background_url = "https:" + background_url;
      $("#click-contain img").attr("src", background_url);
      $("#article-page-overlay").show().css("display", "flex");
    }
  });
  ("use strict");

  $("#show").click(function () {
    $(".max__height--seo").css("max-height", "1000px");
    $(this).hide();
    $("#hide").show();
  });
  $("#hide").click(function () {
    $(".max__height--seo").css("max-height", "27px");
    $(this).hide();
    $("#show").show();
  });
  ("use strict");

  $(".site-header__section--switcher").on("click", function () {
    $(".wg-drop.country-selector .wgcurrent").toggleClass("rotate_arrow");
  });
  ("use strict");

  var _typeof =
    typeof Symbol === "function" && typeof Symbol.iterator === "symbol"
      ? function (obj) {
          return typeof obj;
        }
      : function (obj) {
          return obj &&
            typeof Symbol === "function" &&
            obj.constructor === Symbol &&
            obj !== Symbol.prototype
            ? "symbol"
            : typeof obj;
        };

  !(function (i) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], i)
      : "undefined" != typeof exports
      ? (module.exports = i(require("jquery")))
      : i(jQuery);
  })(function (i) {
    "use strict";
    var e = window.Slick || {};
    ((e = (function () {
      var e = 0;
      return function (t, o) {
        var s,
          n = this;
        (n.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: i(t),
          appendDots: i(t),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next" type="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function customPaging(e, t) {
            return i('<button type="button" />').text(t + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          focusOnChange: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (n.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          i.extend(n, n.initials),
          (n.activeBreakpoint = null),
          (n.animType = null),
          (n.animProp = null),
          (n.breakpoints = []),
          (n.breakpointSettings = []),
          (n.cssTransitions = !1),
          (n.focussed = !1),
          (n.interrupted = !1),
          (n.hidden = "hidden"),
          (n.paused = !0),
          (n.positionProp = null),
          (n.respondTo = null),
          (n.rowCount = 1),
          (n.shouldClick = !0),
          (n.$slider = i(t)),
          (n.$slidesCache = null),
          (n.transformType = null),
          (n.transitionType = null),
          (n.visibilityChange = "visibilitychange"),
          (n.windowWidth = 0),
          (n.windowTimer = null),
          (s = i(t).data("slick") || {}),
          (n.options = i.extend({}, n.defaults, o, s)),
          (n.currentSlide = n.options.initialSlide),
          (n.originalSettings = n.options),
          void 0 !== document.mozHidden
            ? ((n.hidden = "mozHidden"),
              (n.visibilityChange = "mozvisibilitychange"))
            : void 0 !== document.webkitHidden &&
              ((n.hidden = "webkitHidden"),
              (n.visibilityChange = "webkitvisibilitychange")),
          (n.autoPlay = i.proxy(n.autoPlay, n)),
          (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
          (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
          (n.changeSlide = i.proxy(n.changeSlide, n)),
          (n.clickHandler = i.proxy(n.clickHandler, n)),
          (n.selectHandler = i.proxy(n.selectHandler, n)),
          (n.setPosition = i.proxy(n.setPosition, n)),
          (n.swipeHandler = i.proxy(n.swipeHandler, n)),
          (n.dragHandler = i.proxy(n.dragHandler, n)),
          (n.keyHandler = i.proxy(n.keyHandler, n)),
          (n.instanceUid = e++),
          (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          n.registerBreakpoints(),
          n.init(!0);
      };
    })()).prototype.activateADA = function () {
      this.$slideTrack
        .find(".slick-active")
        .attr({ "aria-hidden": "false" })
        .find("a, input, button, select")
        .attr({ tabindex: "0" });
    }),
      (e.prototype.addSlide = e.prototype.slickAdd =
        function (e, t, o) {
          var s = this;
          if ("boolean" == typeof t) (o = t), (t = null);
          else if (t < 0 || t >= s.slideCount) return !1;
          s.unload(),
            "number" == typeof t
              ? 0 === t && 0 === s.$slides.length
                ? i(e).appendTo(s.$slideTrack)
                : o
                ? i(e).insertBefore(s.$slides.eq(t))
                : i(e).insertAfter(s.$slides.eq(t))
              : !0 === o
              ? i(e).prependTo(s.$slideTrack)
              : i(e).appendTo(s.$slideTrack),
            (s.$slides = s.$slideTrack.children(this.options.slide)),
            s.$slideTrack.children(this.options.slide).detach(),
            s.$slideTrack.append(s.$slides),
            s.$slides.each(function (e, t) {
              i(t).attr("data-slick-index", e);
            }),
            (s.$slidesCache = s.$slides),
            s.reinit();
        }),
      (e.prototype.animateHeight = function () {
        var i = this;
        if (
          1 === i.options.slidesToShow &&
          !0 === i.options.adaptiveHeight &&
          !1 === i.options.vertical
        ) {
          var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
          i.$list.animate({ height: e }, i.options.speed);
        }
      }),
      (e.prototype.animateSlide = function (e, t) {
        var o = {},
          s = this;
        s.animateHeight(),
          !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
          !1 === s.transformsEnabled
            ? !1 === s.options.vertical
              ? s.$slideTrack.animate(
                  { left: e },
                  s.options.speed,
                  s.options.easing,
                  t
                )
              : s.$slideTrack.animate(
                  { top: e },
                  s.options.speed,
                  s.options.easing,
                  t
                )
            : !1 === s.cssTransitions
            ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
              i({ animStart: s.currentLeft }).animate(
                { animStart: e },
                {
                  duration: s.options.speed,
                  easing: s.options.easing,
                  step: function step(i) {
                    (i = Math.ceil(i)),
                      !1 === s.options.vertical
                        ? ((o[s.animType] = "translate(" + i + "px, 0px)"),
                          s.$slideTrack.css(o))
                        : ((o[s.animType] = "translate(0px," + i + "px)"),
                          s.$slideTrack.css(o));
                  },
                  complete: function complete() {
                    t && t.call();
                  },
                }
              ))
            : (s.applyTransition(),
              (e = Math.ceil(e)),
              !1 === s.options.vertical
                ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
                : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
              s.$slideTrack.css(o),
              t &&
                setTimeout(function () {
                  s.disableTransition(), t.call();
                }, s.options.speed));
      }),
      (e.prototype.getNavTarget = function () {
        var e = this,
          t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)), t;
      }),
      (e.prototype.asNavFor = function (e) {
        var t = this.getNavTarget();
        null !== t &&
          "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) &&
          t.each(function () {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0);
          });
      }),
      (e.prototype.applyTransition = function (i) {
        var e = this,
          t = {};
        !1 === e.options.fade
          ? (t[e.transitionType] =
              e.transformType +
              " " +
              e.options.speed +
              "ms " +
              e.options.cssEase)
          : (t[e.transitionType] =
              "opacity " + e.options.speed + "ms " + e.options.cssEase),
          !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
      }),
      (e.prototype.autoPlay = function () {
        var i = this;
        i.autoPlayClear(),
          i.slideCount > i.options.slidesToShow &&
            (i.autoPlayTimer = setInterval(
              i.autoPlayIterator,
              i.options.autoplaySpeed
            ));
      }),
      (e.prototype.autoPlayClear = function () {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer);
      }),
      (e.prototype.autoPlayIterator = function () {
        var i = this,
          e = i.currentSlide + i.options.slidesToScroll;
        i.paused ||
          i.interrupted ||
          i.focussed ||
          (!1 === i.options.infinite &&
            (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
              ? (i.direction = 0)
              : 0 === i.direction &&
                ((e = i.currentSlide - i.options.slidesToScroll),
                i.currentSlide - 1 == 0 && (i.direction = 1))),
          i.slideHandler(e));
      }),
      (e.prototype.buildArrows = function () {
        var e = this;
        !0 === e.options.arrows &&
          ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
          (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
          e.slideCount > e.options.slidesToShow
            ? (e.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.htmlExpr.test(e.options.prevArrow) &&
                e.$prevArrow.prependTo(e.options.appendArrows),
              e.htmlExpr.test(e.options.nextArrow) &&
                e.$nextArrow.appendTo(e.options.appendArrows),
              !0 !== e.options.infinite &&
                e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                "aria-disabled": "true",
                tabindex: "-1",
              }));
      }),
      (e.prototype.buildDots = function () {
        var e,
          t,
          o = this;
        if (!0 === o.options.dots) {
          for (
            o.$slider.addClass("slick-dotted"),
              t = i("<ul />").addClass(o.options.dotsClass),
              e = 0;
            e <= o.getDotCount();
            e += 1
          ) {
            t.append(
              i("<li />").append(o.options.customPaging.call(this, o, e))
            );
          }
          (o.$dots = t.appendTo(o.options.appendDots)),
            o.$dots.find("li").first().addClass("slick-active");
        }
      }),
      (e.prototype.buildOut = function () {
        var e = this;
        (e.$slides = e.$slider
          .children(e.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.$slides.each(function (e, t) {
            i(t)
              .attr("data-slick-index", e)
              .data("originalStyling", i(t).attr("style") || "");
          }),
          e.$slider.addClass("slick-slider"),
          (e.$slideTrack =
            0 === e.slideCount
              ? i('<div class="slick-track"/>').appendTo(e.$slider)
              : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
          e.$slideTrack.css("opacity", 0),
          (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
            (e.options.slidesToScroll = 1),
          i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
          e.setupInfinite(),
          e.buildArrows(),
          e.buildDots(),
          e.updateDots(),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          !0 === e.options.draggable && e.$list.addClass("draggable");
      }),
      (e.prototype.buildRows = function () {
        var i,
          e,
          t,
          o,
          s,
          n,
          r,
          l = this;
        if (
          ((o = document.createDocumentFragment()),
          (n = l.$slider.children()),
          l.options.rows > 1)
        ) {
          for (
            r = l.options.slidesPerRow * l.options.rows,
              s = Math.ceil(n.length / r),
              i = 0;
            i < s;
            i++
          ) {
            var d = document.createElement("div");
            for (e = 0; e < l.options.rows; e++) {
              var a = document.createElement("div");
              for (t = 0; t < l.options.slidesPerRow; t++) {
                var c = i * r + (e * l.options.slidesPerRow + t);
                n.get(c) && a.appendChild(n.get(c));
              }
              d.appendChild(a);
            }
            o.appendChild(d);
          }
          l.$slider.empty().append(o),
            l.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (e.prototype.checkResponsive = function (e, t) {
        var o,
          s,
          n,
          r = this,
          l = !1,
          d = r.$slider.width(),
          a = window.innerWidth || i(window).width();
        if (
          ("window" === r.respondTo
            ? (n = a)
            : "slider" === r.respondTo
            ? (n = d)
            : "min" === r.respondTo && (n = Math.min(a, d)),
          r.options.responsive &&
            r.options.responsive.length &&
            null !== r.options.responsive)
        ) {
          s = null;
          for (o in r.breakpoints) {
            r.breakpoints.hasOwnProperty(o) &&
              (!1 === r.originalSettings.mobileFirst
                ? n < r.breakpoints[o] && (s = r.breakpoints[o])
                : n > r.breakpoints[o] && (s = r.breakpoints[o]));
          }
          null !== s
            ? null !== r.activeBreakpoint
              ? (s !== r.activeBreakpoint || t) &&
                ((r.activeBreakpoint = s),
                "unslick" === r.breakpointSettings[s]
                  ? r.unslick(s)
                  : ((r.options = i.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[s]
                    )),
                    !0 === e && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (l = s))
              : ((r.activeBreakpoint = s),
                "unslick" === r.breakpointSettings[s]
                  ? r.unslick(s)
                  : ((r.options = i.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[s]
                    )),
                    !0 === e && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (l = s))
            : null !== r.activeBreakpoint &&
              ((r.activeBreakpoint = null),
              (r.options = r.originalSettings),
              !0 === e && (r.currentSlide = r.options.initialSlide),
              r.refresh(e),
              (l = s)),
            e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
        }
      }),
      (e.prototype.changeSlide = function (e, t) {
        var o,
          s,
          n,
          r = this,
          l = i(e.currentTarget);
        switch (
          (l.is("a") && e.preventDefault(),
          l.is("li") || (l = l.closest("li")),
          (n = r.slideCount % r.options.slidesToScroll != 0),
          (o = n
            ? 0
            : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
          e.data.message)
        ) {
          case "previous":
            (s =
              0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide - s, !1, t);
            break;
          case "next":
            (s = 0 === o ? r.options.slidesToScroll : o),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide + s, !1, t);
            break;
          case "index":
            var d =
              0 === e.data.index
                ? 0
                : e.data.index || l.index() * r.options.slidesToScroll;
            r.slideHandler(r.checkNavigable(d), !1, t),
              l.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (e.prototype.checkNavigable = function (i) {
        var e, t;
        if (((e = this.getNavigableIndexes()), (t = 0), i > e[e.length - 1]))
          i = e[e.length - 1];
        else
          for (var o in e) {
            if (i < e[o]) {
              i = t;
              break;
            }
            t = e[o];
          }
        return i;
      }),
      (e.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots &&
          null !== e.$dots &&
          (i("li", e.$dots)
            .off("click.slick", e.changeSlide)
            .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
            .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
          !0 === e.options.accessibility &&
            e.$dots.off("keydown.slick", e.keyHandler)),
          e.$slider.off("focus.slick blur.slick"),
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
            e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
            !0 === e.options.accessibility &&
              (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
              e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
          e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
          e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
          e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
          e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
          e.$list.off("click.slick", e.clickHandler),
          i(document).off(e.visibilityChange, e.visibility),
          e.cleanUpSlideEvents(),
          !0 === e.options.accessibility &&
            e.$list.off("keydown.slick", e.keyHandler),
          !0 === e.options.focusOnSelect &&
            i(e.$slideTrack).children().off("click.slick", e.selectHandler),
          i(window).off(
            "orientationchange.slick.slick-" + e.instanceUid,
            e.orientationChange
          ),
          i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
          i("[draggable!=true]", e.$slideTrack).off(
            "dragstart",
            e.preventDefault
          ),
          i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
      }),
      (e.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
          e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
      }),
      (e.prototype.cleanUpRows = function () {
        var i,
          e = this;
        e.options.rows > 1 &&
          ((i = e.$slides.children().children()).removeAttr("style"),
          e.$slider.empty().append(i));
      }),
      (e.prototype.clickHandler = function (i) {
        !1 === this.shouldClick &&
          (i.stopImmediatePropagation(),
          i.stopPropagation(),
          i.preventDefault());
      }),
      (e.prototype.destroy = function (e) {
        var t = this;
        t.autoPlayClear(),
          (t.touchObject = {}),
          t.cleanUpEvents(),
          i(".slick-cloned", t.$slider).detach(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.$prevArrow.length &&
            (t.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
          t.$nextArrow &&
            t.$nextArrow.length &&
            (t.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
          t.$slides &&
            (t.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                i(this).attr("style", i(this).data("originalStyling"));
              }),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slideTrack.detach(),
            t.$list.detach(),
            t.$slider.append(t.$slides)),
          t.cleanUpRows(),
          t.$slider.removeClass("slick-slider"),
          t.$slider.removeClass("slick-initialized"),
          t.$slider.removeClass("slick-dotted"),
          (t.unslicked = !0),
          e || t.$slider.trigger("destroy", [t]);
      }),
      (e.prototype.disableTransition = function (i) {
        var e = this,
          t = {};
        (t[e.transitionType] = ""),
          !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
      }),
      (e.prototype.fadeSlide = function (i, e) {
        var t = this;
        !1 === t.cssTransitions
          ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
            t.$slides
              .eq(i)
              .animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
          : (t.applyTransition(i),
            t.$slides.eq(i).css({
              opacity: 1,
              zIndex: t.options.zIndex,
            }),
            e &&
              setTimeout(function () {
                t.disableTransition(i), e.call();
              }, t.options.speed));
      }),
      (e.prototype.fadeSlideOut = function (i) {
        var e = this;
        !1 === e.cssTransitions
          ? e.$slides.eq(i).animate(
              {
                opacity: 0,
                zIndex: e.options.zIndex - 2,
              },
              e.options.speed,
              e.options.easing
            )
          : (e.applyTransition(i),
            e.$slides.eq(i).css({
              opacity: 0,
              zIndex: e.options.zIndex - 2,
            }));
      }),
      (e.prototype.filterSlides = e.prototype.slickFilter =
        function (i) {
          var e = this;
          null !== i &&
            ((e.$slidesCache = e.$slides),
            e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.filter(i).appendTo(e.$slideTrack),
            e.reinit());
        }),
      (e.prototype.focusHandler = function () {
        var e = this;
        e.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick blur.slick", "*", function (t) {
            t.stopImmediatePropagation();
            var o = i(this);
            setTimeout(function () {
              e.options.pauseOnFocus &&
                ((e.focussed = o.is(":focus")), e.autoPlay());
            }, 0);
          });
      }),
      (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
        function () {
          return this.currentSlide;
        }),
      (e.prototype.getDotCount = function () {
        var i = this,
          e = 0,
          t = 0,
          o = 0;
        if (!0 === i.options.infinite) {
          if (i.slideCount <= i.options.slidesToShow) ++o;
          else
            for (; e < i.slideCount; ) {
              ++o,
                (e = t + i.options.slidesToScroll),
                (t +=
                  i.options.slidesToScroll <= i.options.slidesToShow
                    ? i.options.slidesToScroll
                    : i.options.slidesToShow);
            }
        } else if (!0 === i.options.centerMode) o = i.slideCount;
        else if (i.options.asNavFor)
          for (; e < i.slideCount; ) {
            ++o,
              (e = t + i.options.slidesToScroll),
              (t +=
                i.options.slidesToScroll <= i.options.slidesToShow
                  ? i.options.slidesToScroll
                  : i.options.slidesToShow);
          }
        else
          o =
            1 +
            Math.ceil(
              (i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll
            );
        return o - 1;
      }),
      (e.prototype.getLeft = function (i) {
        var e,
          t,
          o,
          s,
          n = this,
          r = 0;
        return (
          (n.slideOffset = 0),
          (t = n.$slides.first().outerHeight(!0)),
          !0 === n.options.infinite
            ? (n.slideCount > n.options.slidesToShow &&
                ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                (s = -1),
                !0 === n.options.vertical &&
                  !0 === n.options.centerMode &&
                  (2 === n.options.slidesToShow
                    ? (s = -1.5)
                    : 1 === n.options.slidesToShow && (s = -2)),
                (r = t * n.options.slidesToShow * s)),
              n.slideCount % n.options.slidesToScroll != 0 &&
                i + n.options.slidesToScroll > n.slideCount &&
                n.slideCount > n.options.slidesToShow &&
                (i > n.slideCount
                  ? ((n.slideOffset =
                      (n.options.slidesToShow - (i - n.slideCount)) *
                      n.slideWidth *
                      -1),
                    (r =
                      (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                  : ((n.slideOffset =
                      (n.slideCount % n.options.slidesToScroll) *
                      n.slideWidth *
                      -1),
                    (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
            : i + n.options.slidesToShow > n.slideCount &&
              ((n.slideOffset =
                (i + n.options.slidesToShow - n.slideCount) * n.slideWidth),
              (r = (i + n.options.slidesToShow - n.slideCount) * t)),
          n.slideCount <= n.options.slidesToShow &&
            ((n.slideOffset = 0), (r = 0)),
          !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
            ? (n.slideOffset =
                (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
                (n.slideWidth * n.slideCount) / 2)
            : !0 === n.options.centerMode && !0 === n.options.infinite
            ? (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
                n.slideWidth)
            : !0 === n.options.centerMode &&
              ((n.slideOffset = 0),
              (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
          (e =
            !1 === n.options.vertical
              ? i * n.slideWidth * -1 + n.slideOffset
              : i * t * -1 + r),
          !0 === n.options.variableWidth &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              !1 === n.options.infinite
                ? n.$slideTrack.children(".slick-slide").eq(i)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(i + n.options.slidesToShow)),
            (e =
              !0 === n.options.rtl
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            !0 === n.options.centerMode &&
              ((o =
                n.slideCount <= n.options.slidesToShow ||
                !1 === n.options.infinite
                  ? n.$slideTrack.children(".slick-slide").eq(i)
                  : n.$slideTrack
                      .children(".slick-slide")
                      .eq(i + n.options.slidesToShow + 1)),
              (e =
                !0 === n.options.rtl
                  ? o[0]
                    ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                    : 0
                  : o[0]
                  ? -1 * o[0].offsetLeft
                  : 0),
              (e += (n.$list.width() - o.outerWidth()) / 2))),
          e
        );
      }),
      (e.prototype.getOption = e.prototype.slickGetOption =
        function (i) {
          return this.options[i];
        }),
      (e.prototype.getNavigableIndexes = function () {
        var i,
          e = this,
          t = 0,
          o = 0,
          s = [];
        for (
          !1 === e.options.infinite
            ? (i = e.slideCount)
            : ((t = -1 * e.options.slidesToScroll),
              (o = -1 * e.options.slidesToScroll),
              (i = 2 * e.slideCount));
          t < i;

        ) {
          s.push(t),
            (t = o + e.options.slidesToScroll),
            (o +=
              e.options.slidesToScroll <= e.options.slidesToShow
                ? e.options.slidesToScroll
                : e.options.slidesToShow);
        }
        return s;
      }),
      (e.prototype.getSlick = function () {
        return this;
      }),
      (e.prototype.getSlideCount = function () {
        var e,
          t,
          o = this;
        return (
          (t =
            !0 === o.options.centerMode
              ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
              : 0),
          !0 === o.options.swipeToSlide
            ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
                if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft)
                  return (e = n), !1;
              }),
              Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1)
            : o.options.slidesToScroll
        );
      }),
      (e.prototype.goTo = e.prototype.slickGoTo =
        function (i, e) {
          this.changeSlide(
            { data: { message: "index", index: parseInt(i) } },
            e
          );
        }),
      (e.prototype.init = function (e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") ||
          (i(t.$slider).addClass("slick-initialized"),
          t.buildRows(),
          t.buildOut(),
          t.setProps(),
          t.startLoad(),
          t.loadSlider(),
          t.initializeEvents(),
          t.updateArrows(),
          t.updateDots(),
          t.checkResponsive(!0),
          t.focusHandler()),
          e && t.$slider.trigger("init", [t]),
          !0 === t.options.accessibility && t.initADA(),
          t.options.autoplay && ((t.paused = !1), t.autoPlay());
      }),
      (e.prototype.initADA = function () {
        var e = this,
          t = Math.ceil(e.slideCount / e.options.slidesToShow),
          o = e.getNavigableIndexes().filter(function (i) {
            return i >= 0 && i < e.slideCount;
          });
        e.$slides
          .add(e.$slideTrack.find(".slick-cloned"))
          .attr({
            "aria-hidden": "true",
            tabindex: "-1",
          })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          null !== e.$dots &&
            (e.$slides
              .not(e.$slideTrack.find(".slick-cloned"))
              .each(function (t) {
                var s = o.indexOf(t);
                i(this).attr({
                  role: "tabpanel",
                  id: "slick-slide" + e.instanceUid + t,
                  tabindex: -1,
                }),
                  -1 !== s &&
                    i(this).attr({
                      "aria-describedby":
                        "slick-slide-control" + e.instanceUid + s,
                    });
              }),
            e.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (s) {
                var n = o[s];
                i(this).attr({ role: "presentation" }),
                  i(this)
                    .find("button")
                    .first()
                    .attr({
                      role: "tab",
                      id: "slick-slide-control" + e.instanceUid + s,
                      "aria-controls": "slick-slide" + e.instanceUid + n,
                      "aria-label": s + 1 + " of " + t,
                      "aria-selected": null,
                      tabindex: "-1",
                    });
              })
              .eq(e.currentSlide)
              .find("button")
              .attr({ "aria-selected": "true", tabindex: "0" })
              .end());
        for (
          var s = e.currentSlide, n = s + e.options.slidesToShow;
          s < n;
          s++
        ) {
          e.$slides.eq(s).attr("tabindex", 0);
        }
        e.activateADA();
      }),
      (e.prototype.initArrowEvents = function () {
        var i = this;
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          (i.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, i.changeSlide),
          i.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, i.changeSlide),
          !0 === i.options.accessibility &&
            (i.$prevArrow.on("keydown.slick", i.keyHandler),
            i.$nextArrow.on("keydown.slick", i.keyHandler)));
      }),
      (e.prototype.initDotEvents = function () {
        var e = this;
        !0 === e.options.dots &&
          (i("li", e.$dots).on(
            "click.slick",
            { message: "index" },
            e.changeSlide
          ),
          !0 === e.options.accessibility &&
            e.$dots.on("keydown.slick", e.keyHandler)),
          !0 === e.options.dots &&
            !0 === e.options.pauseOnDotsHover &&
            i("li", e.$dots)
              .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
              .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
      }),
      (e.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover &&
          (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
          e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
      }),
      (e.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(),
          e.initDotEvents(),
          e.initSlideEvents(),
          e.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on("click.slick", e.clickHandler),
          i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
          !0 === e.options.accessibility &&
            e.$list.on("keydown.slick", e.keyHandler),
          !0 === e.options.focusOnSelect &&
            i(e.$slideTrack).children().on("click.slick", e.selectHandler),
          i(window).on(
            "orientationchange.slick.slick-" + e.instanceUid,
            i.proxy(e.orientationChange, e)
          ),
          i(window).on(
            "resize.slick.slick-" + e.instanceUid,
            i.proxy(e.resize, e)
          ),
          i("[draggable!=true]", e.$slideTrack).on(
            "dragstart",
            e.preventDefault
          ),
          i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
          i(e.setPosition);
      }),
      (e.prototype.initUI = function () {
        var i = this;
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          (i.$prevArrow.show(), i.$nextArrow.show()),
          !0 === i.options.dots &&
            i.slideCount > i.options.slidesToShow &&
            i.$dots.show();
      }),
      (e.prototype.keyHandler = function (i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === i.keyCode && !0 === e.options.accessibility
            ? e.changeSlide({
                data: { message: !0 === e.options.rtl ? "next" : "previous" },
              })
            : 39 === i.keyCode &&
              !0 === e.options.accessibility &&
              e.changeSlide({
                data: { message: !0 === e.options.rtl ? "previous" : "next" },
              }));
      }),
      (e.prototype.lazyLoad = function () {
        function e(e) {
          i("img[data-lazy]", e).each(function () {
            var e = i(this),
              t = i(this).attr("data-lazy"),
              o = i(this).attr("data-srcset"),
              s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
              r = document.createElement("img");
            (r.onload = function () {
              e.animate({ opacity: 0 }, 100, function () {
                o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                  e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                    e.removeAttr(
                      "data-lazy data-srcset data-sizes"
                    ).removeClass("slick-loading");
                  }),
                  n.$slider.trigger("lazyLoaded", [n, e, t]);
              });
            }),
              (r.onerror = function () {
                e
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  n.$slider.trigger("lazyLoadError", [n, e, t]);
              }),
              (r.src = t);
          });
        }

        var t,
          o,
          s,
          n = this;
        if (
          (!0 === n.options.centerMode
            ? !0 === n.options.infinite
              ? (s =
                  (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                  n.options.slidesToShow +
                  2)
              : ((o = Math.max(
                  0,
                  n.currentSlide - (n.options.slidesToShow / 2 + 1)
                )),
                (s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
            : ((o = n.options.infinite
                ? n.options.slidesToShow + n.currentSlide
                : n.currentSlide),
              (s = Math.ceil(o + n.options.slidesToShow)),
              !0 === n.options.fade &&
                (o > 0 && o--, s <= n.slideCount && s++)),
          (t = n.$slider.find(".slick-slide").slice(o, s)),
          "anticipated" === n.options.lazyLoad)
        )
          for (
            var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0;
            a < n.options.slidesToScroll;
            a++
          ) {
            r < 0 && (r = n.slideCount - 1),
              (t = (t = t.add(d.eq(r))).add(d.eq(l))),
              r--,
              l++;
          }
        e(t),
          n.slideCount <= n.options.slidesToShow
            ? e(n.$slider.find(".slick-slide"))
            : n.currentSlide >= n.slideCount - n.options.slidesToShow
            ? e(
                n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)
              )
            : 0 === n.currentSlide &&
              e(
                n.$slider
                  .find(".slick-cloned")
                  .slice(-1 * n.options.slidesToShow)
              );
      }),
      (e.prototype.loadSlider = function () {
        var i = this;
        i.setPosition(),
          i.$slideTrack.css({ opacity: 1 }),
          i.$slider.removeClass("slick-loading"),
          i.initUI(),
          "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
      }),
      (e.prototype.next = e.prototype.slickNext =
        function () {
          this.changeSlide({ data: { message: "next" } });
        }),
      (e.prototype.orientationChange = function () {
        var i = this;
        i.checkResponsive(), i.setPosition();
      }),
      (e.prototype.pause = e.prototype.slickPause =
        function () {
          var i = this;
          i.autoPlayClear(), (i.paused = !0);
        }),
      (e.prototype.play = e.prototype.slickPlay =
        function () {
          var i = this;
          i.autoPlay(),
            (i.options.autoplay = !0),
            (i.paused = !1),
            (i.focussed = !1),
            (i.interrupted = !1);
        }),
      (e.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked ||
          (t.$slider.trigger("afterChange", [t, e]),
          (t.animating = !1),
          t.slideCount > t.options.slidesToShow && t.setPosition(),
          (t.swipeLeft = null),
          t.options.autoplay && t.autoPlay(),
          !0 === t.options.accessibility &&
            (t.initADA(),
            t.options.focusOnChange &&
              i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
      }),
      (e.prototype.prev = e.prototype.slickPrev =
        function () {
          this.changeSlide({ data: { message: "previous" } });
        }),
      (e.prototype.preventDefault = function (i) {
        i.preventDefault();
      }),
      (e.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var t,
          o,
          s,
          n,
          r,
          l = this,
          d = i("img[data-lazy]", l.$slider);
        d.length
          ? ((t = d.first()),
            (o = t.attr("data-lazy")),
            (s = t.attr("data-srcset")),
            (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
            ((r = document.createElement("img")).onload = function () {
              s && (t.attr("srcset", s), n && t.attr("sizes", n)),
                t
                  .attr("src", o)
                  .removeAttr("data-lazy data-srcset data-sizes")
                  .removeClass("slick-loading"),
                !0 === l.options.adaptiveHeight && l.setPosition(),
                l.$slider.trigger("lazyLoaded", [l, t, o]),
                l.progressiveLazyLoad();
            }),
            (r.onerror = function () {
              e < 3
                ? setTimeout(function () {
                    l.progressiveLazyLoad(e + 1);
                  }, 500)
                : (t
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  l.$slider.trigger("lazyLoadError", [l, t, o]),
                  l.progressiveLazyLoad());
            }),
            (r.src = o))
          : l.$slider.trigger("allImagesLoaded", [l]);
      }),
      (e.prototype.refresh = function (e) {
        var t,
          o,
          s = this;
        (o = s.slideCount - s.options.slidesToShow),
          !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
          s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
          (t = s.currentSlide),
          s.destroy(!0),
          i.extend(s, s.initials, { currentSlide: t }),
          s.init(),
          e ||
            s.changeSlide(
              {
                data: {
                  message: "index",
                  index: t,
                },
              },
              !1
            );
      }),
      (e.prototype.registerBreakpoints = function () {
        var e,
          t,
          o,
          s = this,
          n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
          s.respondTo = s.options.respondTo || "window";
          for (e in n) {
            if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
              for (t = n[e].breakpoint; o >= 0; ) {
                s.breakpoints[o] &&
                  s.breakpoints[o] === t &&
                  s.breakpoints.splice(o, 1),
                  o--;
              }
              s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
            }
          }
          s.breakpoints.sort(function (i, e) {
            return s.options.mobileFirst ? i - e : e - i;
          });
        }
      }),
      (e.prototype.reinit = function () {
        var e = this;
        (e.$slides = e.$slideTrack
          .children(e.options.slide)
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.currentSlide >= e.slideCount &&
            0 !== e.currentSlide &&
            (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
          e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
          e.registerBreakpoints(),
          e.setProps(),
          e.setupInfinite(),
          e.buildArrows(),
          e.updateArrows(),
          e.initArrowEvents(),
          e.buildDots(),
          e.updateDots(),
          e.initDotEvents(),
          e.cleanUpSlideEvents(),
          e.initSlideEvents(),
          e.checkResponsive(!1, !0),
          !0 === e.options.focusOnSelect &&
            i(e.$slideTrack).children().on("click.slick", e.selectHandler),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.setPosition(),
          e.focusHandler(),
          (e.paused = !e.options.autoplay),
          e.autoPlay(),
          e.$slider.trigger("reInit", [e]);
      }),
      (e.prototype.resize = function () {
        var e = this;
        i(window).width() !== e.windowWidth &&
          (clearTimeout(e.windowDelay),
          (e.windowDelay = window.setTimeout(function () {
            (e.windowWidth = i(window).width()),
              e.checkResponsive(),
              e.unslicked || e.setPosition();
          }, 50)));
      }),
      (e.prototype.removeSlide = e.prototype.slickRemove =
        function (i, e, t) {
          var o = this;
          if (
            ((i =
              "boolean" == typeof i
                ? !0 === (e = i)
                  ? 0
                  : o.slideCount - 1
                : !0 === e
                ? --i
                : i),
            o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
          )
            return !1;
          o.unload(),
            !0 === t
              ? o.$slideTrack.children().remove()
              : o.$slideTrack.children(this.options.slide).eq(i).remove(),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            (o.$slidesCache = o.$slides),
            o.reinit();
        }),
      (e.prototype.setCSS = function (i) {
        var e,
          t,
          o = this,
          s = {};
        !0 === o.options.rtl && (i = -i),
          (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
          (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
          (s[o.positionProp] = i),
          !1 === o.transformsEnabled
            ? o.$slideTrack.css(s)
            : ((s = {}),
              !1 === o.cssTransitions
                ? ((s[o.animType] = "translate(" + e + ", " + t + ")"),
                  o.$slideTrack.css(s))
                : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"),
                  o.$slideTrack.css(s)));
      }),
      (e.prototype.setDimensions = function () {
        var i = this;
        !1 === i.options.vertical
          ? !0 === i.options.centerMode &&
            i.$list.css({ padding: "0px " + i.options.centerPadding })
          : (i.$list.height(
              i.$slides.first().outerHeight(!0) * i.options.slidesToShow
            ),
            !0 === i.options.centerMode &&
              i.$list.css({ padding: i.options.centerPadding + " 0px" })),
          (i.listWidth = i.$list.width()),
          (i.listHeight = i.$list.height()),
          !1 === i.options.vertical && !1 === i.options.variableWidth
            ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
              i.$slideTrack.width(
                Math.ceil(
                  i.slideWidth * i.$slideTrack.children(".slick-slide").length
                )
              ))
            : !0 === i.options.variableWidth
            ? i.$slideTrack.width(5e3 * i.slideCount)
            : ((i.slideWidth = Math.ceil(i.listWidth)),
              i.$slideTrack.height(
                Math.ceil(
                  i.$slides.first().outerHeight(!0) *
                    i.$slideTrack.children(".slick-slide").length
                )
              ));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        !1 === i.options.variableWidth &&
          i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
      }),
      (e.prototype.setFade = function () {
        var e,
          t = this;
        t.$slides.each(function (o, s) {
          (e = t.slideWidth * o * -1),
            !0 === t.options.rtl
              ? i(s).css({
                  position: "relative",
                  right: e,
                  top: 0,
                  zIndex: t.options.zIndex - 2,
                  opacity: 0,
                })
              : i(s).css({
                  position: "relative",
                  left: e,
                  top: 0,
                  zIndex: t.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          t.$slides
            .eq(t.currentSlide)
            .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
      }),
      (e.prototype.setHeight = function () {
        var i = this;
        if (
          1 === i.options.slidesToShow &&
          !0 === i.options.adaptiveHeight &&
          !1 === i.options.vertical
        ) {
          var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
          i.$list.css("height", e);
        }
      }),
      (e.prototype.setOption = e.prototype.slickSetOption =
        function () {
          var e,
            t,
            o,
            s,
            n,
            r = this,
            l = !1;
          if (
            ("object" === i.type(arguments[0])
              ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
              : "string" === i.type(arguments[0]) &&
                ((o = arguments[0]),
                (s = arguments[1]),
                (l = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === i.type(arguments[1])
                  ? (n = "responsive")
                  : void 0 !== arguments[1] && (n = "single")),
            "single" === n)
          )
            r.options[o] = s;
          else if ("multiple" === n)
            i.each(o, function (i, e) {
              r.options[i] = e;
            });
          else if ("responsive" === n)
            for (t in s) {
              if ("array" !== i.type(r.options.responsive))
                r.options.responsive = [s[t]];
              else {
                for (e = r.options.responsive.length - 1; e >= 0; ) {
                  r.options.responsive[e].breakpoint === s[t].breakpoint &&
                    r.options.responsive.splice(e, 1),
                    e--;
                }
                r.options.responsive.push(s[t]);
              }
            }
          l && (r.unload(), r.reinit());
        }),
      (e.prototype.setPosition = function () {
        var i = this;
        i.setDimensions(),
          i.setHeight(),
          !1 === i.options.fade
            ? i.setCSS(i.getLeft(i.currentSlide))
            : i.setFade(),
          i.$slider.trigger("setPosition", [i]);
      }),
      (e.prototype.setProps = function () {
        var i = this,
          e = document.body.style;
        (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
          "top" === i.positionProp
            ? i.$slider.addClass("slick-vertical")
            : i.$slider.removeClass("slick-vertical"),
          (void 0 === e.WebkitTransition &&
            void 0 === e.MozTransition &&
            void 0 === e.msTransition) ||
            (!0 === i.options.useCSS && (i.cssTransitions = !0)),
          i.options.fade &&
            ("number" == typeof i.options.zIndex
              ? i.options.zIndex < 3 && (i.options.zIndex = 3)
              : (i.options.zIndex = i.defaults.zIndex)),
          void 0 !== e.OTransform &&
            ((i.animType = "OTransform"),
            (i.transformType = "-o-transform"),
            (i.transitionType = "OTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (i.animType = !1)),
          void 0 !== e.MozTransform &&
            ((i.animType = "MozTransform"),
            (i.transformType = "-moz-transform"),
            (i.transitionType = "MozTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.MozPerspective &&
              (i.animType = !1)),
          void 0 !== e.webkitTransform &&
            ((i.animType = "webkitTransform"),
            (i.transformType = "-webkit-transform"),
            (i.transitionType = "webkitTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (i.animType = !1)),
          void 0 !== e.msTransform &&
            ((i.animType = "msTransform"),
            (i.transformType = "-ms-transform"),
            (i.transitionType = "msTransition"),
            void 0 === e.msTransform && (i.animType = !1)),
          void 0 !== e.transform &&
            !1 !== i.animType &&
            ((i.animType = "transform"),
            (i.transformType = "transform"),
            (i.transitionType = "transition")),
          (i.transformsEnabled =
            i.options.useTransform && null !== i.animType && !1 !== i.animType);
      }),
      (e.prototype.setSlideClasses = function (i) {
        var e,
          t,
          o,
          s,
          n = this;
        if (
          ((t = n.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true")),
          n.$slides.eq(i).addClass("slick-current"),
          !0 === n.options.centerMode)
        ) {
          var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
          (e = Math.floor(n.options.slidesToShow / 2)),
            !0 === n.options.infinite &&
              (i >= e && i <= n.slideCount - 1 - e
                ? n.$slides
                    .slice(i - e + r, i + e + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((o = n.options.slidesToShow + i),
                  t
                    .slice(o - e + 1 + r, o + e + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === i
                ? t
                    .eq(t.length - 1 - n.options.slidesToShow)
                    .addClass("slick-center")
                : i === n.slideCount - 1 &&
                  t.eq(n.options.slidesToShow).addClass("slick-center")),
            n.$slides.eq(i).addClass("slick-center");
        } else
          i >= 0 && i <= n.slideCount - n.options.slidesToShow
            ? n.$slides
                .slice(i, i + n.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : t.length <= n.options.slidesToShow
            ? t.addClass("slick-active").attr("aria-hidden", "false")
            : ((s = n.slideCount % n.options.slidesToShow),
              (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
              n.options.slidesToShow == n.options.slidesToScroll &&
              n.slideCount - i < n.options.slidesToShow
                ? t
                    .slice(o - (n.options.slidesToShow - s), o + s)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : t
                    .slice(o, o + n.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false"));
        ("ondemand" !== n.options.lazyLoad &&
          "anticipated" !== n.options.lazyLoad) ||
          n.lazyLoad();
      }),
      (e.prototype.setupInfinite = function () {
        var e,
          t,
          o,
          s = this;
        if (
          (!0 === s.options.fade && (s.options.centerMode = !1),
          !0 === s.options.infinite &&
            !1 === s.options.fade &&
            ((t = null), s.slideCount > s.options.slidesToShow))
        ) {
          for (
            o =
              !0 === s.options.centerMode
                ? s.options.slidesToShow + 1
                : s.options.slidesToShow,
              e = s.slideCount;
            e > s.slideCount - o;
            e -= 1
          ) {
            (t = e - 1),
              i(s.$slides[t])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", t - s.slideCount)
                .prependTo(s.$slideTrack)
                .addClass("slick-cloned");
          }
          for (e = 0; e < o + s.slideCount; e += 1) {
            (t = e),
              i(s.$slides[t])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", t + s.slideCount)
                .appendTo(s.$slideTrack)
                .addClass("slick-cloned");
          }
          s.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              i(this).attr("id", "");
            });
        }
      }),
      (e.prototype.interrupt = function (i) {
        var e = this;
        i || e.autoPlay(), (e.interrupted = i);
      }),
      (e.prototype.selectHandler = function (e) {
        var t = this,
          o = i(e.target).is(".slick-slide")
            ? i(e.target)
            : i(e.target).parents(".slick-slide"),
          s = parseInt(o.attr("data-slick-index"));
        s || (s = 0),
          t.slideCount <= t.options.slidesToShow
            ? t.slideHandler(s, !1, !0)
            : t.slideHandler(s);
      }),
      (e.prototype.slideHandler = function (i, e, t) {
        var o,
          s,
          n,
          r,
          l,
          d = null,
          a = this;
        if (
          ((e = e || !1),
          !(
            (!0 === a.animating && !0 === a.options.waitForAnimate) ||
            (!0 === a.options.fade && a.currentSlide === i)
          ))
        )
          if (
            (!1 === e && a.asNavFor(i),
            (o = i),
            (d = a.getLeft(o)),
            (r = a.getLeft(a.currentSlide)),
            (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
            !1 === a.options.infinite &&
              !1 === a.options.centerMode &&
              (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
          )
            !1 === a.options.fade &&
              ((o = a.currentSlide),
              !0 !== t
                ? a.animateSlide(r, function () {
                    a.postSlide(o);
                  })
                : a.postSlide(o));
          else if (
            !1 === a.options.infinite &&
            !0 === a.options.centerMode &&
            (i < 0 || i > a.slideCount - a.options.slidesToScroll)
          )
            !1 === a.options.fade &&
              ((o = a.currentSlide),
              !0 !== t
                ? a.animateSlide(r, function () {
                    a.postSlide(o);
                  })
                : a.postSlide(o));
          else {
            if (
              (a.options.autoplay && clearInterval(a.autoPlayTimer),
              (s =
                o < 0
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                    : a.slideCount + o
                  : o >= a.slideCount
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? 0
                    : o - a.slideCount
                  : o),
              (a.animating = !0),
              a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
              (n = a.currentSlide),
              (a.currentSlide = s),
              a.setSlideClasses(a.currentSlide),
              a.options.asNavFor &&
                (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <=
                  l.options.slidesToShow &&
                l.setSlideClasses(a.currentSlide),
              a.updateDots(),
              a.updateArrows(),
              !0 === a.options.fade)
            )
              return (
                !0 !== t
                  ? (a.fadeSlideOut(n),
                    a.fadeSlide(s, function () {
                      a.postSlide(s);
                    }))
                  : a.postSlide(s),
                void a.animateHeight()
              );
            !0 !== t
              ? a.animateSlide(d, function () {
                  a.postSlide(s);
                })
              : a.postSlide(s);
          }
      }),
      (e.prototype.startLoad = function () {
        var i = this;
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          (i.$prevArrow.hide(), i.$nextArrow.hide()),
          !0 === i.options.dots &&
            i.slideCount > i.options.slidesToShow &&
            i.$dots.hide(),
          i.$slider.addClass("slick-loading");
      }),
      (e.prototype.swipeDirection = function () {
        var i,
          e,
          t,
          o,
          s = this;
        return (
          (i = s.touchObject.startX - s.touchObject.curX),
          (e = s.touchObject.startY - s.touchObject.curY),
          (t = Math.atan2(e, i)),
          (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
          o <= 45 && o >= 0
            ? !1 === s.options.rtl
              ? "left"
              : "right"
            : o <= 360 && o >= 315
            ? !1 === s.options.rtl
              ? "left"
              : "right"
            : o >= 135 && o <= 225
            ? !1 === s.options.rtl
              ? "right"
              : "left"
            : !0 === s.options.verticalSwiping
            ? o >= 35 && o <= 135
              ? "down"
              : "up"
            : "vertical"
        );
      }),
      (e.prototype.swipeEnd = function (i) {
        var e,
          t,
          o = this;
        if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
          return (o.scrolling = !1), !1;
        if (
          ((o.interrupted = !1),
          (o.shouldClick = !(o.touchObject.swipeLength > 10)),
          void 0 === o.touchObject.curX)
        )
          return !1;
        if (
          (!0 === o.touchObject.edgeHit &&
            o.$slider.trigger("edge", [o, o.swipeDirection()]),
          o.touchObject.swipeLength >= o.touchObject.minSwipe)
        ) {
          switch ((t = o.swipeDirection())) {
            case "left":
            case "down":
              (e = o.options.swipeToSlide
                ? o.checkNavigable(o.currentSlide + o.getSlideCount())
                : o.currentSlide + o.getSlideCount()),
                (o.currentDirection = 0);
              break;
            case "right":
            case "up":
              (e = o.options.swipeToSlide
                ? o.checkNavigable(o.currentSlide - o.getSlideCount())
                : o.currentSlide - o.getSlideCount()),
                (o.currentDirection = 1);
          }
          "vertical" != t &&
            (o.slideHandler(e),
            (o.touchObject = {}),
            o.$slider.trigger("swipe", [o, t]));
        } else
          o.touchObject.startX !== o.touchObject.curX &&
            (o.slideHandler(o.currentSlide), (o.touchObject = {}));
      }),
      (e.prototype.swipeHandler = function (i) {
        var e = this;
        if (
          !(
            !1 === e.options.swipe ||
            ("ontouchend" in document && !1 === e.options.swipe) ||
            (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
          )
        )
          switch (
            ((e.touchObject.fingerCount =
              i.originalEvent && void 0 !== i.originalEvent.touches
                ? i.originalEvent.touches.length
                : 1),
            (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
            !0 === e.options.verticalSwiping &&
              (e.touchObject.minSwipe =
                e.listHeight / e.options.touchThreshold),
            i.data.action)
          ) {
            case "start":
              e.swipeStart(i);
              break;
            case "move":
              e.swipeMove(i);
              break;
            case "end":
              e.swipeEnd(i);
          }
      }),
      (e.prototype.swipeMove = function (i) {
        var e,
          t,
          o,
          s,
          n,
          r,
          l = this;
        return (
          (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
          !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
            ((e = l.getLeft(l.currentSlide)),
            (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
            (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
            (l.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))
            )),
            (r = Math.round(
              Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))
            )),
            !l.options.verticalSwiping && !l.swiping && r > 4
              ? ((l.scrolling = !0), !1)
              : (!0 === l.options.verticalSwiping &&
                  (l.touchObject.swipeLength = r),
                (t = l.swipeDirection()),
                void 0 !== i.originalEvent &&
                  l.touchObject.swipeLength > 4 &&
                  ((l.swiping = !0), i.preventDefault()),
                (s =
                  (!1 === l.options.rtl ? 1 : -1) *
                  (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
                !0 === l.options.verticalSwiping &&
                  (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
                (o = l.touchObject.swipeLength),
                (l.touchObject.edgeHit = !1),
                !1 === l.options.infinite &&
                  ((0 === l.currentSlide && "right" === t) ||
                    (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                  ((o = l.touchObject.swipeLength * l.options.edgeFriction),
                  (l.touchObject.edgeHit = !0)),
                !1 === l.options.vertical
                  ? (l.swipeLeft = e + o * s)
                  : (l.swipeLeft =
                      e + o * (l.$list.height() / l.listWidth) * s),
                !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
                !0 !== l.options.fade &&
                  !1 !== l.options.touchMove &&
                  (!0 === l.animating
                    ? ((l.swipeLeft = null), !1)
                    : void l.setCSS(l.swipeLeft))))
        );
      }),
      (e.prototype.swipeStart = function (i) {
        var e,
          t = this;
        if (
          ((t.interrupted = !0),
          1 !== t.touchObject.fingerCount ||
            t.slideCount <= t.options.slidesToShow)
        )
          return (t.touchObject = {}), !1;
        void 0 !== i.originalEvent &&
          void 0 !== i.originalEvent.touches &&
          (e = i.originalEvent.touches[0]),
          (t.touchObject.startX = t.touchObject.curX =
            void 0 !== e ? e.pageX : i.clientX),
          (t.touchObject.startY = t.touchObject.curY =
            void 0 !== e ? e.pageY : i.clientY),
          (t.dragging = !0);
      }),
      (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
        function () {
          var i = this;
          null !== i.$slidesCache &&
            (i.unload(),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slidesCache.appendTo(i.$slideTrack),
            i.reinit());
        }),
      (e.prototype.unload = function () {
        var e = this;
        i(".slick-cloned", e.$slider).remove(),
          e.$dots && e.$dots.remove(),
          e.$prevArrow &&
            e.htmlExpr.test(e.options.prevArrow) &&
            e.$prevArrow.remove(),
          e.$nextArrow &&
            e.htmlExpr.test(e.options.nextArrow) &&
            e.$nextArrow.remove(),
          e.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (e.prototype.unslick = function (i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]), e.destroy();
      }),
      (e.prototype.updateArrows = function () {
        var i = this;
        Math.floor(i.options.slidesToShow / 2),
          !0 === i.options.arrows &&
            i.slideCount > i.options.slidesToShow &&
            !i.options.infinite &&
            (i.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            i.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            0 === i.currentSlide
              ? (i.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                i.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : i.currentSlide >= i.slideCount - i.options.slidesToShow &&
                !1 === i.options.centerMode
              ? (i.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                i.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : i.currentSlide >= i.slideCount - 1 &&
                !0 === i.options.centerMode &&
                (i.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                i.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (e.prototype.updateDots = function () {
        var i = this;
        null !== i.$dots &&
          (i.$dots.find("li").removeClass("slick-active").end(),
          i.$dots
            .find("li")
            .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
            .addClass("slick-active"));
      }),
      (e.prototype.visibility = function () {
        var i = this;
        i.options.autoplay &&
          (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
      }),
      (i.fn.slick = function () {
        var i,
          t,
          o = this,
          s = arguments[0],
          n = Array.prototype.slice.call(arguments, 1),
          r = o.length;
        for (i = 0; i < r; i++) {
          if (
            ("object" ==
              (typeof s === "undefined" ? "undefined" : _typeof(s)) ||
            void 0 === s
              ? (o[i].slick = new e(o[i], s))
              : (t = o[i].slick[s].apply(o[i].slick, n)),
            void 0 !== t)
          )
            return t;
        }
        return o;
      });
  });
  ("use strict");

  var printElement = document.getElementById("print--card");

  if (printElement) {
    printElement.addEventListener("click", function () {
      window.print();
    });
  }
  ("use strict");

  $("ul.sidebar-accordion")
    .find("li.extend")
    .click(function () {
      $("li.extend.active").not($(this)).toggleClass("active");
      //Expand or collapse this panel
      $(this).next().slideToggle("fast");
      $(this).toggleClass("active");
      //Hide the other panels
      $("ul.extended-submenu").not($(this).next()).slideUp("fast");
    });

  $("#moreDetails").on("click", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("html, body").animate(
        {
          scrollTop:
            $(".ProductDescription--mobile-container").offset().top - 140,
        },
        600
      );
    } else {
      $("html, body").animate(
        {
          scrollTop: $(".ProductDescription").offset().top - 200,
        },
        600
      );
    }
  });

  $(".tabs").each(function () {
    var active,
      content,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });

  $("#details__anchor").on("click", function () {
    var id = $(this).attr("href");

    $("html, body").animate(
      {
        scrollTop: $(id).offset().top - 150,
      },
      500
    );
  });
  ("use strict");

  var prevArrow =
    '<svg class="slick-arrow--left" viewBox="0 0 53.4 18.8"><defs><style>.cls-1{fill:#404040;}</style></defs><path class="cls-1" d="M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z"/></svg>';
  var nextArrow =
    '<svg class="slick-arrow--right" x="0px" y="0px"viewBox="0 0 53.4 18.8" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"> <style type="text/css"> .st0{fill:#404040;} </style> <path class="st0" d="M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z"/> </svg>';

  $("#slider--product").slick({
    dots: false,
    infinite: true,
    arrows: false,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
        },
      },
    ],
  });

  $("#slider--product").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $("#slider__nav--product .carousel-cell").removeClass("is-nav-selected");
      $(
        '#slider__nav--product .carousel-cell[thumb-index="' + nextSlide + '"]'
      ).addClass("is-nav-selected");
    }
  );

  $("#slider__nav--product .carousel-cell").on("click", function () {
    var index = $(this).attr("thumb-index");
    $("#slider__nav--product .carousel-cell").removeClass("is-nav-selected");
    $(this).addClass("is-nav-selected");
    $("#slider--product").slick("slickGoTo", index);
  });

  // var featuredImage = $('#slider--product').attr('current-image');
  // if (featuredImage) {
  //   var imageNumber = parseInt($(`#slider--product .product__image[image-id="${featuredImage}"]`).attr("slide-number"));
  //   $('#slider--product').slick('slickGoTo', imageNumber);
  // }

  $(".carousel-product-list-1").slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
  });

  $(".carousel-product-list-2").slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 2,
    slidesToScroll: 1,
  });

  $("#instagram-feed").slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  $(".slider__etape-routine").slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  $(".article-back-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: ".article-back-slider2",
  });
  $(".article-back-slider2").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".article-back-slider",
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
  });

  // Init image selection according to variant
  var productDetails = {};
  if ($("[product-details]").html()) {
    productDetails = JSON.parse($("[product-details]").html());
  }
  var selecteVariantId = $(
    ".product__description--container .add__to__cart"
  ).attr("variant-id");
  var imageNumberInit;
  if (productDetails.variants) {
    productDetails.variants.forEach(function (variant) {
      if (variant.id == selecteVariantId) {
        var featuredImage = variant.imageId;
        imageNumberInit =
          parseInt(
            $(
              '#slider--product .product__image[image-id="' +
                featuredImage +
                '"]'
            ).attr("slide-number")
          ) - 1;
      }
    });
  }
  ("use strict");

  var productDetails = {};
  if ($("[product-details]").html()) {
    productDetails = JSON.parse($("[product-details]").html());
  }

  $(".quantity__change--selector-product").on("click", function () {
    var type = $(this).attr("type");
    var currentQty = parseInt(
      $(".product__qty--container .quantity__current").val()
    );

    if (type == "minus") {
      if (currentQty != 0) {
        $(".product__qty--container .quantity__current").val(currentQty - 1);
      }
    } else {
      $(".product__qty--container .quantity__current").val(currentQty + 1);
    }
  });

  $(".anchor--details").on("click", function () {
    var id = $(this).attr("href");

    $("html, body").animate(
      {
        scrollTop: $(id).offset().top - 70,
      },
      500
    );
  });

  $("#recharge__select").on("click", function () {
    onOptionChanged("option1");
  });

  document.addEventListener(
    "select-changed:product__option--1",
    function (event) {
      if (event.detail.quickAdd == "true") {
        onOptionChangedQuickAdd();
      } else {
        onOptionChanged("option1");
      }
    },
    false
  );
  document.addEventListener(
    "select-changed:product__option--2",
    function (event) {
      if (event.detail.quickAdd == "true") {
        onOptionChangedQuickAdd();
      } else {
        onOptionChanged("option2");
      }
    },
    false
  );
  document.addEventListener(
    "select-changed:product__option--3",
    function (event) {
      if (event.detail.quickAdd == "true") {
        onOptionChangedQuickAdd();
      } else {
        onOptionChanged("option3");
      }
    },
    false
  );

  // Change variant for bulles
  $(".bulle__custom--value").on("click", function () {
    var value = $(this).find(".variant--choice--title").text();
    var option = $(this).attr("for");
    var disable_abo = $(this).data("noabo");
    $('.select__custom--selected-value[for="' + option + '"]').text(value);
    $('.bulle__custom--value[for="' + option + '"]').removeClass("is__active");
    $(this).addClass("is__active");

    document.dispatchEvent(
      new CustomEvent("select-changed:" + option, {
        detail: { quickAdd: "false" },
      })
    );
  });

  function updateProductButton(variant, productId, optionNumber, subscription) {
    var price = parseFloat(variant.price.replace("€", "").replace(",", "."));
    var compareAtPrice = parseFloat(
      variant.compareAtPrice.replace("€", "").replace(",", ".")
    );
    var subscriptionPrice = 0.9 * price;

    if (variant.available == 0) {
      $('.add__to__cart[product-id="' + productId + '"]').html(
        '<span class="text__center fw--700 main__title--blog-categories">\n          RUPTURE DE STOCK - ALERTE STOCK\n        </span>'
      );
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "id",
        "BIS_trigger"
      );
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "variant-available",
        false
      );
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "data-variant-id",
        variant.id
      );
      var _noabo = $(".bulle__custom--value.is__active").attr("data-noabo");
      var _subscriptionPrice_txt = Math.round(subscriptionPrice * 100) / 100;
      if ((subscriptionPrice * 100) % 10 == 0) {
        _subscriptionPrice_txt = subscriptionPrice + "0";
      }
      var _price_txt = Math.round(price * 100) / 100;

      if (_price_txt % 1 != 0) {
        if ((_price_txt * 10) % 1 == 0) {
          _price_txt += "0";
        }
      }
      // DESACTIVE SELECT ABO SI UNAVAILABLE
      if (_noabo == "true") {
        $("#recharge__select").addClass("unavailable");
        $(".recharge--selector[type='classic']").addClass("selected");
        $(".recharge--selector[type='subscription']").removeClass("selected");
      } else {
        console.log("available abo");
        $("#recharge__select").removeClass("unavailable");
        $("#recharge--price .reduced-price").html(_subscriptionPrice_txt + "€");
        $("#recharge--price .original-price").html(_price_txt + "€");
      }
    } else {
      // if (compareAtPrice > price) {
      //   $(`.add__to__cart[product-id="${productId}"]`).html(`Ajouter au panier - <span id="product-price" style="margin-left: 3px;">${price}€</span>`)
      // } else {
      //   $(`.add__to__cart[product-id="${productId}"]`).html(`Ajouter au panier - <span id="product-price" style="margin-left: 3px;">${price}€</span>`)
      // }

      $(".variant--price").text(price + "€");
      $("#variant--price").text(price + "€");

      var _is_ml = false;

      var _format = $(".bulle__custom--value.is__active").attr("data-format");
      var _noabo = $(".bulle__custom--value.is__active").attr("data-noabo");
      console.log("ABO:" + _noabo);
      if (_format == "Taille") {
        _is_ml = true;
      }

      if (variant.option1.indexOf("mL") > -1) {
        $(".variant--contenance").text(variant.option1);
      }

      // DESACTIVE SELECT ABO SI UNAVAILABLE
      if (_noabo == "true") {
        $("#recharge__select").addClass("unavailable");
        $(".recharge--selector[type='classic']").addClass("selected");
        $(".recharge--selector[type='subscription']").removeClass("selected");
      } else {
        console.log("available abo");
        $("#recharge__select").removeClass("unavailable");
      }

      var _subscriptionPrice_txt = Math.round(subscriptionPrice * 100) / 100;
      if ((subscriptionPrice * 100) % 10 == 0) {
        _subscriptionPrice_txt = subscriptionPrice + "0";
      }
      var _price_txt = Math.round(price * 100) / 100;

      if (_price_txt % 1 != 0) {
        if ((_price_txt * 10) % 1 == 0) {
          _price_txt += "0";
        }
      }

      if (subscription == false) {
        $('.add__to__cart[product-id="' + productId + '"]').html(
          'Ajouter au panier - <span id="product-price" style="margin-left: 3px;">' +
            price +
            "\u20AC</span>"
        );

        if (_noabo != "true") {
          $("#recharge--price .reduced-price").html(
            _subscriptionPrice_txt + "€"
          );
          $("#recharge--price .original-price").html(_price_txt + "€");
        }
      } else {
        if (_noabo != "true") {
          $('.add__to__cart[product-id="' + productId + '"]').html(
            'Ajouter au panier - <span id="product-price" style="margin-left: 3px;">' +
              _subscriptionPrice_txt +
              "\u20AC</span>"
          );
          $(".data__product--container .variant--price").text(
            _subscriptionPrice_txt + "€"
          );
          $("#recharge--price .reduced-price").html(
            _subscriptionPrice_txt + "€"
          );
          $("#recharge--price .original-price").html(_price_txt + "€");
        } else {
          $('.add__to__cart[product-id="' + productId + '"]').html(
            'Ajouter au panier - <span id="product-price" style="margin-left: 3px;">' +
              _price_txt +
              "\u20AC</span>"
          );
          $(".data__product--container .variant--price").text(_price_txt + "€");
        }
      }

      if (compareAtPrice > price) {
        $(".variant--contenance").prepend(
          '<span style="text-decoration: line-through;">' +
            compareAtPrice +
            "€</span> | "
        );
      }

      // Gestion du changement de variante

      if (_noabo != "true") {
        if (subscriptionPrice % 1 != 0) {
          subscriptionPrice = Math.round(subscriptionPrice * 10) / 10;
          //subscriptionPrice += "0";
        }
        console.log("___ cas 1 : " + subscriptionPrice);
        $("#recharge--price .reduced-price").text(subscriptionPrice + "€");
      }

      $('.add__to__cart[product-id="' + productId + '"]').attr("id", "");
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "variant-available",
        true
      );

      /*
    var _ps_price = $("")
        $("span[slot='spDisplayAmount']").html();

 */
    }
  }

  function onOptionChanged(optionNumber) {
    var productOptions = [];
    console.log("Option changed : " + optionNumber);
    console.log(productDetails.variants);
    console.log("Product option : ");
    console.log(productOptions);

    for (var i = 1; i <= 3; i++) {
      productOptions[i - 1] =
        $(
          '.select__custom--selected-value[product-id="' +
            productDetails.productId +
            '"][name="product__option--' +
            i +
            '"]'
        )
          .text()
          .trim() || "";
    }
    if (productDetails && productDetails.variants.length > 1) {
      productDetails.variants.forEach(function (variant) {
        if (
          variant.option1 == productOptions[0] &&
          variant.option2 == productOptions[1] &&
          variant.option3 == productOptions[2]
        ) {
          var subscription = false;
          console.log("Product price 1 : " + variant.price);
          $("#product-price").text(variant.price);
          $(".product--compare-at-price").text(variant.compareAtPrice);
          if (
            $('.recharge--selector.selected[type="subscription"]').length > 0
          ) {
            subscription = true;
            $(
              '.add__to__cart[product-id="' + productDetails.productId + '"]'
            ).attr("variant-id", variant.rechargeVariant);
          } else {
            $(
              '.add__to__cart[product-id="' + productDetails.productId + '"]'
            ).attr("variant-id", variant.id);
          }

          var url =
            document.location.origin +
            document.location.pathname +
            ("?variant=" + variant.id);
          window.history.replaceState({ path: url }, "", url);
          var featuredImage = variant.imageId;

          // Change image on variant change
          var imageNumber = parseInt(
            $(
              '#slider--product .product__image[image-id="' +
                featuredImage +
                '"]'
            ).attr("slide-number")
          );
          if (imageNumber) {
            $("#slider--product").slick("slickGoTo", imageNumber - 1);
          }

          updateProductButton(
            variant,
            productDetails.productId,
            optionNumber,
            subscription
          );
        } else {
          console.log("CAS NON GERE");
        }
      });
    } else if (productDetails && productDetails.variants.length == 1) {
      console.log("Product price 2 : " + productDetails.variants[0]);
      if ($('.recharge--selector.selected[type="subscription"]').length > 0) {
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr(
          "variant-id",
          productDetails.variants[0].rechargeVariant
        );
      } else {
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr(
          "variant-id",
          productDetails.variants[0].id
        );
      }
    }
  }

  if ($("#slider--product").length) {
    let variant_id = $(".add__to__cart--container")
      .find("button")
      .attr("variant-id");
    if (productDetails && productDetails.variants.length > 1) {
      productDetails.variants.forEach(function (variant) {
        console.log(variant);
        console.log(variant_id);
        if (variant.id == variant_id) {
          var price = parseFloat(variant.price.replace("€", ""));
          var compareAtPrice = parseFloat(
            variant.compareAtPrice.replace("€", "")
          );

          var featuredImage = variant.imageId;
          var imageNumber = parseInt(
            $(
              '#slider--product .product__image[image-id="' +
                featuredImage +
                '"]'
            ).attr("slide-number")
          );
          console.log(imageNumber);
          if (imageNumber) {
            $("#slider--product").slick("slickGoTo", imageNumber - 1);
          }
          if (variant.option1.indexOf("mL") > -1) {
            $(".variant--contenance").text(variant.option1);
          }
          if (compareAtPrice > price) {
            $(".variant--contenance").prepend(
              '<span style="text-decoration: line-through;">' +
                compareAtPrice +
                "€</span> | "
            );
          }
        }
      });
    }
  }

  // Breadcrumb

  var ua = navigator.userAgent,
    clickByUa =
      ua.match(/iPad/i) || ua.match(/iPhone/) ? "touchstart" : "click";

  $(".go--back, .go--back-device").on(clickByUa, function () {
    if (window.location.href.indexOf("blogs") > -1) {
      window.location = $(this).attr("link");
    } else {
      if (document.referrer.indexOf(window.location.hostname) > -1) {
        window.history.back();
      } else {
        window.location = $(this).attr("link");
      }
    }
  });

  $(".text-why-recharge").on("click", function () {
    $(".content-why-recharge").toggleClass("opened");
  });
  $(document).on("click", function (e) {
    var container = $(".content-why-recharge");
    var container2 = $(".text-why-recharge");
    if (container2.is(e.target) && container2.has(e.target).length === 0) {
    } else if (
      container.hasClass("opened") &&
      !container.is(e.target) &&
      container.has(e.target).length === 0
    ) {
      $(".content-why-recharge").removeClass("opened");
    }
  });
  ("use strict");

  document.addEventListener("product-grid-modal:open", function (event) {
    $(".modal-has-to-load").hide();

    if (event.detail.productHandle) {
      jQuery.ajax({
        type: "GET",
        url: "/products/" + event.detail.productHandle + ".js",
        dataType: "json",
        success: function success(product) {
          window.productGridDetails = product;
          var variant;

          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].available == true) {
              variant = product.variants[i];
              break;
            }
          }

          var compareAtprice = variant.compare_at_price;
          var price = variant.price;

          $("#product-grid-modal .product--price").text(displayPrice(price));
          if (compareAtprice > price) {
            var percentagePromo =
              "- " +
              Math.floor(
                ((parseInt(compareAtprice) - parseInt(price)) /
                  parseInt(compareAtprice)) *
                  100
              ) +
              "%";
            $("#product-grid-modal .body__text--collection-promo").text(
              percentagePromo
            );
            $("#product-grid-modal .sales__tag--container").show();
            $("#product-grid-modal .product--compare-at-price").text(
              displayPrice(compareAtprice)
            );
          } else {
            $("#product-grid-modal .product--compare-at-price").text("");
            $("#product-grid-modal .sales__tag--container").hide();
          }

          updateProductButtonQuickAdd(variant);

          $("#product-grid-modal .product__title").text(
            window.productGridDetails.title
          );
          $("#product-grid-modal .product__brand").text(
            window.productGridDetails.vendor
          );
          $("#product-grid-modal .featured--img").attr(
            "src",
            window.productGridDetails.featured_image
          );
          $("#product--select").html("");

          for (var j = 1; j <= product.options.length; j++) {
            var liList = "";
            var controlArray = [];
            for (var i = 0; i < product.variants.length; i++) {
              var variant = product.variants[i];
              if (controlArray.indexOf(variant["option" + j]) == -1) {
                liList =
                  liList +
                  ('<li class="select__custom--value ' +
                    (i == 0 ? "is__active" : "") +
                    '" product-grid="true" value="' +
                    variant["option" + j] +
                    '" for="product__option--' +
                    j +
                    '">' +
                    variant["option" + j] +
                    "</li>");
                controlArray.push(variant["option" + j]);
              }
            }

            var optionList = "";
            for (var i = 0; i < product.variants.length; i++) {
              var variant = product.variants[i];
              optionList =
                optionList +
                ('<option value="' +
                  variant["option" + j] +
                  '">' +
                  variant["option" + j] +
                  "</option>");
            }

            $("#product--select").append(
              '<div class="select__custom--container button__action position__relative" >\n            <div class="select__custom--selected-value-container button__action flex fd--row space__between" for="product__option--' +
                j +
                '">\n              <span class="mh--10 margin__left--none fw--700">\n              ' +
                product.options[j - 1].name +
                '\n              </span>\n              <div id="select__custom--' +
                j +
                '" class="select__custom--selected-value margin__left--auto" for="select" name="product__option--' +
                j +
                '">\n               ' +
                product.variants[0].options[j - 1] +
                '\n              </div>\n              <span class="mh--20 margin__right--none">\n                <svg class="icon--svg icon--arrow-bottom" role="presentation" viewBox="0 0 21 11">\n                  <polyline fill="none" stroke="currentColor" points="0.5 0.5 10.5 10.5 20.5 0.5" stroke-width="1.25"></polyline>\n                </svg>\n              </span>\n            </div>\n\n            <div class="select__custom--values" for="product__option--' +
                j +
                '">\n              <ul>\n                ' +
                liList +
                '\n              </ul>\n            </div>\n            <select class="select__hidden" for="product__option--' +
                j +
                '">\n              ' +
                optionList +
                "\n            </select>\n          </div>"
            );
          }
        },
      });
    }
  });

  $(".add__to__cart--quick-add").on("click", function () {
    var available = $(this).attr("variant-available");
    if (available == "true") {
      $("#product-grid-modal").removeClass("opened");
      $("#page__overlay").removeClass("opened");
    }
  });

  var image = $(".featured--img");
  image.on("load", function () {
    $(".modal-loader").hide();
    $(".modal-has-to-load").fadeIn("300");
  });
  ("use strict");

  function addItemToCart(
    variant_id,
    quantity,
    shipping_interval_frequency,
    shipping_interval_unit_type
  ) {
    var data = {
      quantity: quantity,
      id: variant_id,
      "properties[shipping_interval_frequency]": shipping_interval_frequency,
      "properties[shipping_interval_unit_type]": shipping_interval_unit_type,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function success() {
        renderCart();
        updateCartData();
        document.dispatchEvent(new CustomEvent("cart_drawer:open"));
      },
    });
  }

  // Product page
  $(".recharge--selector").on("click", function () {
    $(".recharge--selector").removeClass("selected");
    $(this).addClass("selected");
    if ($(this).attr("type") == "classic") {
      console.log(
        "Product price 2 : recharge--selector classic : " +
          $("#variant--price").text()
      );
      $("#product-price").text($("#variant--price").text());
      $("#recharge-frequency").prop("disabled", "disabled");
    } else {
      console.log(
        "Product price 3 : recharge--selector not classic : " +
          $("#recharge--price .reduced-price").text()
      );
      $("#product-price").text($("#recharge--price .reduced-price").text());
      $("#recharge-frequency").prop("disabled", false);

      // Handle change Taille --> only for oOlution
      var grandeTaille = $(
        '.select__custom--value[subscription-variant="taille--big"]'
      ).text();
      var tailleSelectionnee = $("#select__custom--1").text();
      if (grandeTaille && grandeTaille != tailleSelectionnee) {
        $('.select__custom--value[subscription-variant="taille--big"]').click();
        $("#selected--taille").text($("#select__custom--1").text());
        console.log("CAS 4");
        $("#product-price").text($("#recharge--price").text());
      }
    }
  });

  document.addEventListener(
    "select-changed:product__option--1",
    function (event) {
      var grandeTaille = $(
        '.select__custom--value[subscription-variant="taille--big"]'
      ).text();
      var tailleSelectionnee = $("#select__custom--1").text();
      var subscriptionSelected = false;
      if ($('.recharge--selector.selected[type="subscription"]').length > 0) {
        subscriptionSelected = true;
      }
      if (
        subscriptionSelected &&
        grandeTaille &&
        grandeTaille != tailleSelectionnee
      ) {
        $('.recharge--selector[type="classic"]').click();
      }
    },
    false
  );

  // get totalPrice for recharge
  var getCartTotal = function getCartTotal(callback, cart) {
    if (cart) {
      if (callback) {
        callback(cart.total_price);
      } else {
        return cart.total_price;
      }
    } else {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function success(cart) {
          if (callback) {
            callback(cart.total_price);
          } else {
            return cart.total_price;
          }
        },
      });
    }
  };

  var updateprice = function updateprice(totalPrice) {
    $(".cart__total--drawer").text(displayPrice(totalPrice));
  };

  // Cart --> calculate initial price
  var rechargeInitCartPrice = function rechargeInitCartPrice() {
    var cartTotalPrice = getCartTotal(updateprice);
  };

  rechargeInitCartPrice();

  // Recharge update line_item
  $("body").on("click", ".toggle--subscription", function () {
    var key = $(this).attr("key");
    $('.recharge__ci--toggle[key="' + key + '"]').click();
  });

  $("body").on("click", ".recharge__ci--toggle", function () {
    $(this).children(".icon--validate").toggleClass("display__none");
    var subscription = $(this).attr("subscription");
    var key = $(this).attr("key");
    var qty = $(this).attr("qty");
    var objUpdateOld = { updates: {} };
    objUpdateOld.updates[key] = 0;

    var variantId = $(this).attr("variant-recharge-id");
    if (subscription == "true") {
      variantId = $(this).attr("variant-shopify-id");
    }
    var objUpdateNew = { quantity: qty, id: variantId };
    if (subscription != "true") {
      objUpdateNew["properties[recharge_prevent]"] = "false";
      objUpdateNew["properties[shipping_interval_frequency]"] = 1;
      objUpdateNew["properties[shipping_interval_unit_type]"] = "Months";
      objUpdateNew["properties[recharge]"] = true;
    }

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: objUpdateOld,
      dataType: "json",
      success: function success(response) {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: objUpdateNew,
          dataType: "json",
          success: function success(response) {
            renderCart();
            updateCartData();
          },
          error: function error(_error) {
            console.log("erreur");
            console.log(_error);
          },
        });
      },
      error: function error(_error2) {
        console.log("erreur");
        console.log(_error2);
      },
    });
  });

  $("body").on("change", ".recharge-frequency", function () {
    $(this).children(".icon--validate").toggleClass("display__none");
    var key = $(this).attr("key");
    var qty = $(this).attr("qty");
    var frequency = $(this).val();
    var objUpdate = { id: key, qty: qty };

    objUpdate.properties = {
      recharge: "true",
      shipping_interval_unit_type: $(this).attr("unit_type"),
      shipping_interval_frequency: frequency,
      frequencies: $(this).attr("frequency").split(","),
    };
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: objUpdate,
      dataType: "json",
      success: function success(response) {
        renderCart();
        updateCartData();
      },
      error: function error(_error3) {
        console.log("erreur");
      },
    });
  });

  // Handle submit cart
  // Fonction pour attendre que le widget ReCharge soit initialisé
  function waitForReChargeWidget(callback, maxAttempts = 10) {
    var attempts = 0;
    
    function checkWidget() {
      attempts++;
      var container = document.querySelector('#rc_container');
      var onetimeRadio = document.querySelector('#rc_purchase_type_onetime');
      var autodeliverRadio = document.querySelector('#rc_purchase_type_autodeliver');
      
      console.log('🔍 [ReCharge] Tentative', attempts, 'de détection du widget:', {
        container: !!container,
        containerVisible: container ? container.style.display !== 'none' : false,
        onetimeRadio: !!onetimeRadio,
        autodeliverRadio: !!autodeliverRadio,
        containerHTML: container ? container.innerHTML.substring(0, 200) + '...' : 'null'
      });
      
      // Vérifier si les éléments ReCharge sont présents (même s'ils sont cachés)
      if (container && (onetimeRadio || autodeliverRadio)) {
        console.log('✅ [ReCharge] Widget détecté dans le DOM');
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkWidget, 500);
      } else {
        console.log('❌ [ReCharge] Widget non trouvé après', maxAttempts, 'tentatives');
        callback(); // Appeler quand même pour ne pas bloquer
      }
    }
    
    checkWidget();
  }

  // Fonction pour récupérer les données ReCharge
  function getReChargeData() {
    var rechargeData = {
      isSubscription: false,
      sellingPlanId: null
    };
    
    // --- Détection widget ReCharge v4 ---
    var rechargeWidget = document.querySelector('recharge-subscription-widget');
    if (rechargeWidget) {
      console.log('🔍 [ReCharge] Widget ReCharge v4 détecté');
      // 1. Cherche le champ caché généré par le widget v4
      var input = document.querySelector('input[type="hidden"][name="selling_plan"]');
      if (input && input.value) {
        rechargeData.isSubscription = true;
        rechargeData.sellingPlanId = input.value;
        console.log('✅ [ReCharge] selling_plan détecté via champ caché :', input.value);
        return rechargeData;
      }
      // 2. Fallback : regarde si l'option abonnement est cochée
      var subRadio = rechargeWidget.querySelector('input[type="radio"][name="purchaseOption"][value="subscription"]');
      if (subRadio && subRadio.checked) {
        rechargeData.isSubscription = true;
        rechargeData.sellingPlanId = null;
        console.log('⚠️ [ReCharge] Abonnement sélectionné mais pas de selling_plan détecté');
        return rechargeData;
      }
      // 3. Sinon, achat unique
      rechargeData.isSubscription = false;
      rechargeData.sellingPlanId = null;
      console.log('🔍 [ReCharge] Achat unique sélectionné (v4)');
      return rechargeData;
    }
    
    // Vérifier si le widget ReCharge v3 existe (ancienne version)
    var container = document.querySelector('#rc_container');
    if (!container) {
      console.log('🔍 [ReCharge] Widget ReCharge non trouvé dans le DOM');
      
      // Essayer d'autres sélecteurs d'abonnement
      var alternativeSelectors = [
        'input[value="subscription"]:checked',
        'input[value="rc_subscription"]:checked',
        'input[data-purchase-type="subscription"]:checked',
        '[data-recharge-purchase-type="subscription"][data-checked="true"]',
        '.rc-option--subscription.rc-option--selected',
        'recharge-subscription-widget input[type="radio"][value="subscription"]:checked',
        '.recharge--selector.selected[type="subscription"]',
        '.recharge--selector[type="subscription"]:checked'
      ];
      
      for (var i = 0; i < alternativeSelectors.length; i++) {
        var element = document.querySelector(alternativeSelectors[i]);
        if (element) {
          console.log('🔍 [ReCharge] Élément d\'abonnement trouvé avec sélecteur:', alternativeSelectors[i]);
          rechargeData.isSubscription = true;
          
          // Essayer de trouver un selling plan
          var sellingPlanSelectors = [
            'input[name*="selling_plan"]:checked',
            'select[name*="selling_plan"] option:checked',
            '[data-selling-plan-id]',
            '.recharge-frequency:checked'
          ];
          
          for (var j = 0; j < sellingPlanSelectors.length; j++) {
            var sellingPlanElement = document.querySelector(sellingPlanSelectors[j]);
            if (sellingPlanElement) {
              rechargeData.sellingPlanId = sellingPlanElement.value || 
                                          sellingPlanElement.dataset.sellingPlanId ||
                                          sellingPlanElement.getAttribute('data-selling-plan-id');
              console.log('🔍 [ReCharge] Selling plan trouvé:', rechargeData.sellingPlanId);
              break;
            }
          }
          break;
        }
      }
      
      return rechargeData;
    }
    
    // Sélecteurs spécifiques au widget ReCharge v3 officiel
    var onetimeRadio = document.querySelector('#rc_purchase_type_onetime');
    var autodeliverRadio = document.querySelector('#rc_purchase_type_autodeliver');
    var frequencySelect = document.querySelector('#rc_shipping_interval_frequency');
    
    console.log('🔍 [ReCharge] Éléments v3 trouvés:', {
      container: !!container,
      onetimeRadio: !!onetimeRadio,
      autodeliverRadio: !!autodeliverRadio,
      frequencySelect: !!frequencySelect,
      containerDisplay: container ? container.style.display : 'null'
    });
    
    // Vérifier l'état d'abonnement
    if (autodeliverRadio && autodeliverRadio.checked) {
      rechargeData.isSubscription = true;
      
      // Récupérer la fréquence sélectionnée
      if (frequencySelect) {
        var selectedFrequency = frequencySelect.value;
        console.log('🔍 [ReCharge] Fréquence sélectionnée:', selectedFrequency);
        
        // Construire le selling plan ID basé sur la fréquence
        // Format: {variant_id}_{frequency}_{unit_type}
        var variantId = document.querySelector('input[name="id"]') ? 
                       document.querySelector('input[name="id"]').value : null;
        var unitType = document.querySelector('#rc_shipping_interval_unit_type') ? 
                      document.querySelector('#rc_shipping_interval_unit_type').value : 'Months';
        
        if (variantId && selectedFrequency) {
          rechargeData.sellingPlanId = variantId + '_' + selectedFrequency + '_' + unitType.toLowerCase();
          console.log('🔍 [ReCharge] Selling plan ID construit:', rechargeData.sellingPlanId);
        }
      }
    } else if (onetimeRadio && onetimeRadio.checked) {
      rechargeData.isSubscription = false;
      rechargeData.sellingPlanId = null;
    }
    
    console.log('🔍 [ReCharge] Données récupérées dans theme-apm.js:', rechargeData);
    return rechargeData;
  }

  var checkoutUrl = function checkoutUrl() {
    function get_cookie(name) {
      return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
    }

    var token;
    do {
      token = get_cookie("cart");
    } while (token == undefined);

    var myshopify_domain = window.recharge.domain;

    try {
      var ga_linker = ga.getAll()[0].get("linkerParam");
    } catch (err) {
      var ga_linker = "";
    }

    var customer_param = window.recharge.customerParams;
    return (
      "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
      myshopify_domain +
      "&cart_token=" +
      token +
      "&" +
      ga_linker +
      "&" +
      customer_param
    );
  };

  $("#checkout--button").on("click", function (e) {
    if ($('.recharge__ci--toggle[subscription="true"]').length > 0) {
      var rechargeUrl = checkoutUrl();
      document.location.href = rechargeUrl;
    } else {
      document.location.href = "/checkout";
    }
  });
});
